import axios from "axios";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";

import {
  SelectionState,
  PagingState,
  IntegratedPaging,
  IntegratedSelection,
  EditingState,
} from "@devexpress/dx-react-grid";
import {
  Grid,
  Table,
  TableHeaderRow,
  TableSelection,
  PagingPanel,
  TableColumnResizing,
  TableColumnReordering,
  TableFixedColumns,
  DragDropProvider,
  TableEditRow,
  TableInlineCellEditing,
} from "@devexpress/dx-react-grid-bootstrap4";
import "@devexpress/dx-react-grid-bootstrap4/dist/dx-react-grid-bootstrap4.css";
import { fetchMarkTypeRequest } from "../../../../../store/actions";
import { useSelector } from "react-redux";
import axiosMain from "../../../../../http/axios/axios_main";
import CustomToast from "../../../../../components/Toast";
import { useAuctionDetail } from "../../../../../components/common/AunctioneerDeteailProvider";
import formatDateToDdMmYy from "../../../../../components/common/dateAndTime/convertToDate";
import ConfirmationModal from "../../../../../components/common/DeleteConfirmationModal";
import UploadValuation from "../../../auctioncatalog/UploadValuation";
import UpdateValuation from "../../../auctioncatalog/UpdateValuation";
import { NoAdultContentOutlined } from "@mui/icons-material";
import { Pagination } from "@mui/material";
import { useLoader } from "../../../../../components/common/Loder/Loder";
import * as Yup from "yup";
import Modals from "../../../../../components/common/Modal";
import { useMemo } from "react";

const tableMessages = {
  noData: "No Records Found",
};

const KutchaTable = ({
  rows,
  setRows,
  status,
  modalRight,
  baseUrlEng,
  auctionType,
  formik,
  markTypeValue,
  getkutcha,
  saleProgramId,
}) => {
  const {
    auctionDetailId,
    auctionCenterUserId,
    auctionCenterId,
    userId,
    auction,
    roleCode,
  } = useAuctionDetail();
  const [editingRowIds, setEditingRowIds] = useState([]);
  const [rowChanges, setRowChanges] = useState({});
  const [data, setData] = useState([]);
  const [selectedData, setSelectedData] = useState([]);
  const [checked, setChecked] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [editing, setEditing] = useState(false);

  const [validationErrors, setValidationErrors] = useState([]);

  const [allCheked, setAllChacked] = useState(false);
  const [getDataByPrems, setGetDataByprems] = useState([]);
  const [openUploadUpdateValuation, setOpenUploadUpdateValuation] =
    useState(false);
  const [auctioncatalogIdforupload, setauctioncatalogIdforupload] = useState(0);
  const [selection, setSelection] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [columns, setColumns] = useState([
    // { label: "Lot No.", id: "LotNo" },
    { label: "Invoice No.", id: "invoiceNo" },
    { label: "Origin", id: "origin" },
    { label: "Tea Type", id: "teaTypeName" },
    { label: "Sub Tea Type", id: "subTeaTypeName" },
    { label: "Category", id: "categoryName" },
    { label: "Mark", id: "markName" },
    { label: "Session Type", id: "sessionTypeName" },
    { label: "Grade", id: "gradeName" },
    { label: "Package Type", id: "packageType" },
    { label: "Package No.", id: "packageNo" },
    { label: "No. of Packages", id: "totalPackages" },
    { label: "Sample Qty.(Kgs)", id: "SampleQty" },
    { label: "Gross Weight", id: "grossKgs" },
    { label: "Tare Weight", id: "tareKgs" },
    { label: "Net Weight", id: "netKgs" },
    { label: "Invoice Weight", id: "invoiceWeight" },
    { label: "Short/Excess Weight", id: "shortExcessWeight" },
    { label: "Manufacture From Date", id: "manufactureFromDate" },
    { label: "Manufacture To Date", id: "manufactureToDate" },
    { label: "GP No", id: "gpNo" },
    { label: "GP Date", id: "gpDate" },
    { label: "Base Price", id: "basePrice" },
    { label: "Auctioneer's Valuation", id: "auctioneerValuation" },
    { label: "Reserve Price", id: "reservePrice" },
    { label: "Price Increment", id: "priceIncrement" },
    { label: "Mark Package Comments", id: "markPackageComments" },
    { label: "Lot Comments", id: "lotComments" },
    { label: "Quality Comments", id: "qualityComments" },
    { label: "Quality Certification", id: "qualityCertification" },
    { label: "Brew Color", id: "brewColor" },
    { label: "Age of Products", id: "ageOfProducts" },
    { label: "Brewers Comments", id: "brewersComments" },
    { label: "Garden Certification", id: "gardenCertification" },
    { label: "Warehouse Unit Code", id: "wareHouseName" },
    { label: "Location Inside Warehouse", id: "locationInsideWarehouse" },
    { label: "Remarks", id: "remarks" },
    { label: "Last Modified By", id: "lastModifiedBy" },
    { label: "Market Type", id: "marketTypeName" },
    { label: "System Base Price", id: "SystemBasePrice" },
  ]);
  const [editableCell, setEditableCell] = useState({
    rowId: null,
    columnName: null,
  });
  const inputRefs = useRef([]);
  const selectRefs = useRef([]);
  const tableRef = useRef(null);

  const preventBlurRef = useRef(false);
  const [count, setcount] = useState(0);
  const dispatch = useDispatch();
  const { isLoading, openLoader, closeLoader, toggleLoader } = useLoader();
  const [rowColorchange, setRowcolorChange] = useState(null);
  useEffect(() => {
    // console.log(data, "datadatadata");
    setRows(data);
  }, [selectedData]);
  const [sessiontyp, setsessiontyp] = useState([]);

  const [openModalConformation, setOpenModalConformation] = useState(false);
  const [dataFlag, setDataFlag] = useState(false);
  const [openModalConformationTitle, setOpenModalConformationTitle] =
    useState("");
  const [changed, setchanged] = useState({});
  const [selectAll, setSelectAll] = useState(false);
  useEffect(() => {
    if (data.length === 0 && rows.length > 0) {
      // let newData = [];
      let data = rows?.map((ele, index) => {
        return {
          ...ele,
          gpDate: ele.gpDate === null ? "-" : formatDateToDdMmYy(ele.gpDate), //formatDateToDdMmYy()+ "T" + ele.gpDate?.split("T")?.at(1), With Time
          manufactureFromDate:
            ele.manufactureFromDate === null
              ? "-"
              : formatDateToDdMmYy(ele.manufactureFromDate?.split("T")?.at(0)),
          manufactureToDate:
            ele.manufactureToDate === null
              ? "-"
              : formatDateToDdMmYy(ele.manufactureToDate?.split("T")?.at(0)),
        };
      });
      // console.log(data, "datadata");
      // for (let i = 0; i < 10; i++) {
      //   newData.push(data?.at(i));
      // }
      setData(data);
      // console.log(data, "newDatanewDatanewDatanewDatanewData");
    }
    // else
    // setData([]);
    if (rows.length === 0) {
      setData([]);
    }
    setRowcolorChange([]);
  }, [rows]);
  useEffect(() => {
    if (baseUrlEng === "EnglishAuctionKutchaCatalogue") {
      const API_URL = `/preauction/Common/BindSessionType`;
      const dt =
        baseUrlEng === "EnglishAuctionKutchaCatalogue" ? "ENGLISH" : "BHARAT";
      axiosMain.get(API_URL + "?auctionTypeCode=" + dt, {}).then((res) => {
        if (res?.data?.message) {
          setsessiontyp(res.data.responseData);
        } else {
          setsessiontyp([]);
        }
      });
    }
    const handleClickOutside = (event) => {
      if (tableRef.current && !tableRef.current.contains(event.target)) {
        //debugger;
        setEditableCell({ rowId: null, columnName: null });
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleChangePage = (e, value) => {
    let indexs = rows.length < value * 10 ? rows.length : value * 10;
    let newData = [];

    for (let i = indexs - 10; i < indexs; i++) {
      newData.push(rows?.at(i));
    }

    console.log(indexs, "newDatanewDatanewDatanewDatanewData");

    // for (let i = data.lenght; i < data.lenght + 10; i++) {
    //   newData.push(rows);
    // }
    // let data = newData
    //   ?.filter((ele, index) => index < data.lenght + 10)
    //   ?.map((ele, index) => {
    //     return {
    //       ...ele,
    //       gpDate: ele.gpDate === null ? "-" : formatDateToDdMmYy(ele.gpDate), //formatDateToDdMmYy()+ "T" + ele.gpDate?.split("T")?.at(1), With Time
    //       manufactureFromDate:
    //         ele.manufactureFromDate === null
    //           ? "-"
    //           : formatDateToDdMmYy(ele.manufactureFromDate?.split("T")?.at(0)),
    //       manufactureToDate:
    //         ele.manufactureToDate === null
    //           ? "-"
    //           : formatDateToDdMmYy(ele.manufactureToDate?.split("T")?.at(0)),
    //     };
    // });
    // console.log(data, "datadata");
    setData(newData);
  };
  //
  useEffect(() => {
    if (data.length > 1) {
      setAllChacked(selectedData.length === data.length ? true : false);
    } else {
      setAllChacked(false);
    }
  }, [selectedData]);
  const handleCheckboxChange = (id) => {
    const isChecked = selectedData.some((item) => item.KutchaCatalogId === id);

    if (isChecked) {
      // If the checkbox is checked, remove the data from selectedData
      setSelectedData(
        selectedData.filter((item) => item.KutchaCatalogId !== id)
      );
      // setAllChacked(selectedData.length === data.length ? true:false);
    } else {
      // If the checkbox is unchecked, add the data to selectedData
      const data2 = data.find((item) => item.KutchaCatalogId === id);
      setSelectedData([...selectedData, data2]);
      // setAllChacked(selectedData.length === data.length ? true:false);
    }
  };
  const handleSliceData = (idsToSlice) => {
    const slicedData = data.filter(
      (item) => !idsToSlice.includes(item.KutchaCatalogId)
    );
    //data.filter((item,index) => item.KutchaCatalogId=== idsToSlice[index])
    setData(slicedData);
  };
  console.log(selectedData, "selectedData");
  // const handleDeleteSelected = async () => {
  //   // setData((prevData) => prevData.filter((item) => !item.selected));
  //   console.log(
  //     data.map((ele) => ele.KutchaCatalogId).join(", "),
  //     data,
  //     "checkedDatacheckedDatacheckedData"
  //   );

  //   if (data?.length > 0) {
  //     try {
  //       const response = await axiosMain.post(
  //         "/preauction/${baseUrlEng}/DeleteKutchaCatalogueDetails",
  //         {
  //           season: data?.at(0)?.season,
  //           saleNo: data?.at(0)?.saleNo,
  //           KutchaCatalogIds: selectedData
  //             .map((ele) => ele.KutchaCatalogId)
  //             .join(", "),
  //           userId: userId,
  //           auctionCenterId: auctionCenterId,
  //         }
  //       );

  //       if (response.status === 200) {
  //         CustomToast.success(response.data.message);
  //       }
  //     } catch (error) {
  //       console.error("Error deleting:", error);
  //       CustomToast.error("An error occurred while deleting.");
  //     }
  //   } else {
  //   }
  // };

  const handleEditToggle = () => {
    setEditing(!editing);
  };

  const handleSaveCell = (id, field, value) => {
    console.log(id, field, value, "id, field, value");
    // code by SDP
    const noDecimalFields = [
      "basePrice",
      "reservePrice",
      "auctioneerValuation",
    ];

    if (noDecimalFields.includes(field?.toString())) {
      let isDecimal = /^\d+\.\d+$/.test(value.toString()); // Matches numbers with a decimal point
      let isValidWholeNumber = /^\d+$/.test(value.toString()); // Matches whole numbers only
      if (isValidWholeNumber) {
        // Update state if valid
        setData((prevData) =>
          prevData.map((item) =>
            item.KutchaCatalogId === id ? { ...item, [field]: value } : item
          )
        );
        setSelectedData((prevData) =>
          prevData.map((item) =>
            item.KutchaCatalogId === id ? { ...item, [field]: value } : item
          )
        );
        // Remove any previous validation errors for this field
        setValidationErrors(validationErrors?.filter((ele) => ele.id !== id));
      } else {
        setData((prevData) =>
          prevData.map((item) =>
            item.KutchaCatalogId === id ? { ...item, [field]: value } : item
          )
        );
        setSelectedData((prevData) =>
          prevData.map((item) =>
            item.KutchaCatalogId === id ? { ...item, [field]: value } : item
          )
        );
        if (value === "") {
          setValidationErrors(validationErrors?.filter((ele) => ele.id !== id));
        } else {
          setValidationErrors((prevErrors) => [
            ...prevErrors.filter(
              (ele) => ele.id !== id || ele[field] === undefined
            ),
            {
              id,
              [field]:
                field?.toString() === "basePrice"
                  ? "Base Price Can not have Decimal value."
                  : field?.toString() === "reservePrice"
                    ? "Reserve Price Can not have Decimal value."
                    : "Auctioneer valuation Can not have Decimal value.",
            },
          ]);
        }
      }
      return; // Exit the function
    }
    //END

    if (
      field?.toString() === "SampleQty" ||
      field?.toString() === "grossKgs" ||
      field?.toString() === "shortExcessWeight" ||
      // field?.toString() === "basePrice" ||
      // field?.toString() === "reservePrice" ||
      // field?.toString() === "auctioneerValuation"
      field?.toString() === "priceIncrement"
    ) {
      let isValid = /^\d+(\.\d{1,2})?$/.test(value.toString());
      if (isValid) {
        setData((prevData) =>
          prevData.map((item) =>
            item.KutchaCatalogId === id ? { ...item, [field]: value } : item
          )
        );
        setSelectedData((prevData) =>
          prevData.map((item) =>
            item.KutchaCatalogId === id ? { ...item, [field]: value } : item
          )
        );
        setValidationErrors(validationErrors?.filter((ele) => ele.id !== id));
      } else {
        setData((prevData) =>
          prevData.map((item) =>
            item.KutchaCatalogId === id ? { ...item, [field]: value } : item
          )
        );
        setSelectedData((prevData) =>
          prevData.map((item) =>
            item.KutchaCatalogId === id ? { ...item, [field]: value } : item
          )
        );
        // console.log("Sample Qwantity is able to dasimal");
        if (validationErrors?.lenght > 0) {
          setValidationErrors((prevErrors) => [
            ...prevErrors,
            {
              id,
              [field]: "Two digits after decimal point allowed.",
            },
          ]);
        } else {
          setValidationErrors([
            {
              id,
              [field]: "Two digits after decimal point allowed.",
            },
          ]);
        }

        return;
      }
    }
    if (field?.toString() === "grossKgs") {
      const dataList = data
        .filter((item) => item.KutchaCatalogId === id)
        ?.at(0);

      let greatestValue = Math.max(
        parseFloat(value),
        parseFloat(dataList.SampleQty)
      );

      if (
        greatestValue === parseFloat(value) &&
        parseFloat(value) !== parseFloat(dataList.SampleQty)
      ) {
        let netKgsValue = value - dataList.tareKgs;

        let noOfKgs = dataList.totalPackages * netKgsValue;
        let smapQty = dataList.SampleQty + dataList.shortExcessWeight;
        setData((prevData) =>
          prevData.map((item) =>
            item.KutchaCatalogId === id
              ? {
                ...item,
                [field]: value,
                netKgs: value - dataList.tareKgs,
                invoiceWeight: noOfKgs - smapQty,
              }
              : item
          )
        );
        setSelectedData((prevData) =>
          prevData.map((item) =>
            item.KutchaCatalogId === id
              ? {
                ...item,
                [field]: value,
                netKgs: value - dataList.tareKgs,
                invoiceWeight: noOfKgs - smapQty,
              }
              : item
          )
        );
        setValidationErrors(validationErrors?.filter((ele) => ele.id !== id));
      } else {
        setData((prevData) =>
          prevData.map((item) =>
            item.KutchaCatalogId === id
              ? { ...item, [field]: value, netKgs: 0, invoiceWeight: 0 }
              : item
          )
        );
        setSelectedData((prevData) =>
          prevData.map((item) =>
            item.KutchaCatalogId === id
              ? { ...item, [field]: value, netKgs: 0, invoiceWeight: 0 }
              : item
          )
        );
        // console.log("Sample Qwantity is able to dasimal");
        if (validationErrors?.lenght > 0) {
          setValidationErrors((prevErrors) => [
            ...prevErrors,
            {
              id,
              grossKgs: "Gross Weight cannot be less than sampling Qty.",
            },
          ]);
        } else {
          setValidationErrors([
            {
              id,
              grossKgs: "Gross Weight cannot be less than sampling Qty.",
            },
          ]);
        }
      }

      // console.log(
      //   parseFloat(dataList.SampleQty),
      //   field,
      //   "dataListdataListdataList"
      // );
    } else {
      // console.log(data);
      setData((prevData) =>
        prevData.map((item) =>
          item.KutchaCatalogId === id ? { ...item, [field]: value } : item
        )
      );
      setSelectedData((prevData) =>
        prevData.map((item) =>
          item.KutchaCatalogId === id ? { ...item, [field]: value } : item
        )
      );
    }

    // if (
    //   // field?.toString() === "auctioneerValuation" ||
    //   field?.toString() === "markPackageComments" ||
    //   field?.toString() === "lotComments" ||
    //   field?.toString() === "qualityComments"
    // ) {
    //   const regex = /^[a-zA-Z0-9!@#$%^&*()_+{}\[\]:;<>,.?~\\/\-|]+$/;

    //   if (regex.test(value) || value === "") {
    //     setData((prevData) =>
    //       prevData.map((item) =>
    //         item.KutchaCatalogId === id ? { ...item, [field]: value } : item
    //       )
    //     );
    //     setSelectedData((prevData) =>
    //       prevData.map((item) =>
    //         item.KutchaCatalogId === id ? { ...item, [field]: value } : item
    //       )
    //     );
    //     setValidationErrors(validationErrors?.filter((ele) => ele.id !== id));
    //   } else {
    //     setData((prevData) =>
    //       prevData.map((item) =>
    //         item.KutchaCatalogId === id ? { ...item, [field]: value } : item
    //       )
    //     );
    //     setSelectedData((prevData) =>
    //       prevData.map((item) =>
    //         item.KutchaCatalogId === id ? { ...item, [field]: value } : item
    //       )
    //     );
    //     // console.log("Sample Qwantity is able to dasimal");
    //     if (validationErrors?.lenght > 0) {
    //       setValidationErrors((prevErrors) => [
    //         ...prevErrors,
    //         {
    //           id,
    //           [field]: "Two digits after decimal point allowed.",
    //         },
    //       ]);
    //     } else {
    //       setValidationErrors([
    //         {
    //           id,
    //           [field]: "Two digits after decimal point allowed.",
    //         },
    //       ]);
    //     }

    //     return;
    //   }
    // } else {
    //   // //debugger;
    //   setValidationErrors([]);
    // }
    //---------------------------chnages

    if (
      field?.toString() === "qualityCertification"
      // field?.toString() === "markPackageComments" ||
      // field?.toString() === "lotComments" ||
      // field?.toString() === "qualityComments" || field?.toString() === "qualityCertification"
      // || field?.toString() === "brewColor" || field?.toString() === "brewersComments"
    ) {
      // const regex = /^[a-zA-Z0-9!@#$%^&*()_+{}\[\]:;<>,.?~\\/\-|]+$/;
      const regex = /^[a-zA-Z0-9&\-\s]{1,500}$/;

      if (regex.test(value) || value === "") {
        setData((prevData) =>
          prevData.map((item) =>
            item.KutchaCatalogId === id ? { ...item, [field]: value } : item
          )
        );
        setSelectedData((prevData) =>
          prevData.map((item) =>
            item.KutchaCatalogId === id ? { ...item, [field]: value } : item
          )
        );
        setValidationErrors(validationErrors?.filter((ele) => ele.id !== id));
      } else {
        setData((prevData) =>
          prevData.map((item) =>
            item.KutchaCatalogId === id ? { ...item, [field]: value } : item
          )
        );
        setSelectedData((prevData) =>
          prevData.map((item) =>
            item.KutchaCatalogId === id ? { ...item, [field]: value } : item
          )
        );
        // console.log("Sample Qwantity is able to dasimal");
        if (validationErrors?.lenght > 0) {
          setValidationErrors((prevErrors) => [
            ...prevErrors,
            {
              id,
              [field]:
                "The length of the field can be  500 alpha numeric. It should allow special characters ‘&’,’-‘.",
            },
          ]);
        } else {
          setValidationErrors([
            {
              id,
              [field]:
                "The length of the field can be  500 alpha numeric. It should allow special characters ‘&’,’-‘.",
            },
          ]);
        }

        return;
      }
    } else if (
      field?.toString() === "brewersComments"
      // field?.toString() === "markPackageComments" ||
      // field?.toString() === "lotComments" ||
      // field?.toString() === "qualityComments" || field?.toString() === "qualityCertification"
      // || field?.toString() === "brewColor" || field?.toString() === "brewersComments"
    ) {
      // const regex = /^[a-zA-Z0-9!@#$%^&*()_+{}\[\]:;<>,.?~\\/\-|]+$/;
      const regex = /^[a-zA-Z0-9&\-\s]{1,200}$/;

      if (regex.test(value) || value === "") {
        setData((prevData) =>
          prevData.map((item) =>
            item.KutchaCatalogId === id ? { ...item, [field]: value } : item
          )
        );
        setSelectedData((prevData) =>
          prevData.map((item) =>
            item.KutchaCatalogId === id ? { ...item, [field]: value } : item
          )
        );
        setValidationErrors(validationErrors?.filter((ele) => ele.id !== id));
      } else {
        setData((prevData) =>
          prevData.map((item) =>
            item.KutchaCatalogId === id ? { ...item, [field]: value } : item
          )
        );
        setSelectedData((prevData) =>
          prevData.map((item) =>
            item.KutchaCatalogId === id ? { ...item, [field]: value } : item
          )
        );
        // console.log("Sample Qwantity is able to dasimal");
        if (validationErrors?.lenght > 0) {
          setValidationErrors((prevErrors) => [
            ...prevErrors,
            {
              id,
              [field]:
                "The length of the field can be 200 alpha numeric. It should allow special characters ‘&’,’-‘.",
            },
          ]);
        } else {
          setValidationErrors([
            {
              id,
              [field]:
                "The length of the field can be 200 alpha numeric. It should allow special characters ‘&’,’-‘.",
            },
          ]);
        }

        return;
      }
    } else if (field?.toString() === "brewColor") {
      const regex = /^[a-zA-Z0-9 ]{1,100}$/;

      if (regex.test(value) || value === "") {
        setData((prevData) =>
          prevData.map((item) =>
            item.KutchaCatalogId === id ? { ...item, [field]: value } : item
          )
        );
        setSelectedData((prevData) =>
          prevData.map((item) =>
            item.KutchaCatalogId === id ? { ...item, [field]: value } : item
          )
        );
        setValidationErrors(validationErrors?.filter((ele) => ele.id !== id));
      } else {
        setData((prevData) =>
          prevData.map((item) =>
            item.KutchaCatalogId === id ? { ...item, [field]: value } : item
          )
        );
        setSelectedData((prevData) =>
          prevData.map((item) =>
            item.KutchaCatalogId === id ? { ...item, [field]: value } : item
          )
        );
        // console.log("Sample Qwantity is able to dasimal");
        if (validationErrors?.lenght > 0) {
          setValidationErrors((prevErrors) => [
            ...prevErrors,
            {
              id,
              [field]:
                "The length of the field 100 alpha numeric. It should not allow special characters",
            },
          ]);
        } else {
          setValidationErrors([
            {
              id,
              [field]:
                "The length of the field 100 alpha numeric. It should not allow special characters",
            },
          ]);
        }

        return;
      }
    } else {
      // //debugger;
      setValidationErrors([]);
    }

    // if (!value) {
    //   setValidationErrors((prevErrors) => ({
    //     ...prevErrors,
    //     [field]: "Field is required.",
    //   }));
    //   return;
    // }

    // setValidationErrors((prevErrors) => ({
    //   ...prevErrors,
    //   [field]: "", // Clear the error message
    // }));
  };
  const newhandleCheckboxChange = (itemId) => {
    const updatedSelection = selectedRows.includes(itemId)
      ? selectedRows.filter((id) => id !== itemId)
      : [...selectedRows, itemId];
    setSelectedRows(updatedSelection);
  };
  // const handleSaveCell = (id, field, value) => {
  //   setData((prevData) =>
  //     prevData.map((item) =>
  //       item.KutchaCatalogId === id ? { ...item, [field]: value } : item
  //     )
  //   );
  // };
  const KuchaketCatalogForAuctioneer = [
    "Lot No.",
    "Invoice No.",
    "Origin",
    "Tea Type",
    "Sub Tea Type",
    "Category",
    "Mark",
    "Session Type",
    "Grade",
    "Package Type",
    "Package No.",
    "No. of Packages",
    "Sample Qty.(Kgs)",
    "Gross Weight",
    "Tare Weight",
    "Net Weight",
    "Invoice Weight",
    "Short/Excess Weight",
    "Manufacture From Date",
    "Manufacture To Date",
    "GP No",
    "GP Date",
    "Base Price",
    "Reserve Price",
    "Auctioneer's Valuation",
    // "Default value should be 1 and hidden",
    "Mark & Package Comments",
    "Lot Comments",
    "Quality Comments",
    "Price Increment",
    // "Quality Certification",
    // "Brew Color",
    // "Age of Products (In Months)",
    // "Brewers Comments",
    // "Garden Certification",
    "Warehouse Unit Code",
    "Location Inside Warehouse",
    "Remarks",
    "Last Modified By",
    "Market  / Lot Type",
    "Action",
    // "action",
  ];
  const [columnsOfKutchaAuctioner, setolumnsOfKutchaAuctioner] = useState([
    // { title: "Lot No.", name: "LotNo" },
    { title: "Invoice No.", name: "invoiceNo" },
    { title: "Origin", name: "origin" },
    { title: "Tea Type", name: "teaTypeName" },
    { title: "Sub Tea Type", name: "subTeaTypeName" },
    { title: "Category", name: "categoryName" },
    { title: "Mark", name: "markName" },
    { title: "Session Type", name: "sessionTypeName" },
    { title: "Grade", name: "gradeName" },
    { title: "Package Type", name: "packageType" },
    { title: "Package No.", name: "packageNo" },
    { title: "No. of Packages", name: "totalPackages" },
    { title: "Sample Qty.(Kgs)", name: "SampleQty" },
    { title: "Gross Weight", name: "grossKgs" },
    { title: "Tare Weight", name: "tareKgs" },
    { title: "Net Weight", name: "netKgs" },
    { title: "Invoice Weight", name: "invoiceWeight" },
    { title: "Short/Excess Weight", name: "shortExcessWeight" },
    { title: "Manufacture From Date", name: "manufactureFromDate" },
    { title: "Manufacture To Date", name: "manufactureToDate" },
    { title: "GP No", name: "gpNo" },
    { title: "GP Date", name: "gpDate" },
    { title: "Base Price", name: "basePrice" },
    { title: "Reserve Price", name: "reservePrice" },
    { title: "Auctioneer's Valuation", name: "auctioneerValuation" },
    { title: "Mark & Package Comments", name: "markPackageComments" },
    { title: "Lot Comments", name: "lotComments" },
    { title: "Quality Comments", name: "qualityComments" },
    { title: "Price Increment", name: "priceIncrement" },
    { title: "Warehouse Unit Code", name: "wareHouseName" },
    { title: "Location Inside Warehouse", name: "locationInsideWarehouse" },
    { title: "Remarks", name: "remarks" },
    { title: "Last Modified By", name: "lastModifiedBy" },
    { title: "Market / Lot Type", name: "lotType" },
    { title: "Action", name: "action" },
  ]);

  // Extract property names from the first data object
  const propertyNames =
    auctionType === "ENGLISH"
      ? [
        "LotNo",
        "invoiceNo",
        "origin",
        "teaTypeName",
        "subTeaTypeName",
        "categoryName",
        "markName",
        "sessionTypeName",
        "gradeName",
        "packageType",
        "packageNo",
        "totalPackages",
        "SampleQty",
        "grossKgs",
        "tareKgs",
        "netKgs",
        "invoiceWeight",
        "shortExcessWeight",
        "manufactureFromDate",
        "manufactureToDate",
        "gpNo",
        "gpDate",
        "basePrice",
        "reservePrice",
        "auctioneerValuation",
        "markPackageComments",
        "lotComments",
        "qualityComments",
        "priceIncrement",
        "wareHouseName",
        "locationInsideWarehouse",
        "remarks",
        "lastModifiedBy",
        "lotType",
        "action",
      ]
      : [
        "LotNo",
        "invoiceNo",
        "origin",
        "teaTypeName",
        "subTeaTypeName",
        "categoryName",
        "markName",
        "sessionTypeName",
        "gradeName",
        "packageType",
        "packageNo",
        "totalPackages",
        "SampleQty",
        "grossKgs",
        "tareKgs",
        "netKgs",
        "invoiceWeight",
        "shortExcessWeight",
        "manufactureFromDate",
        "manufactureToDate",
        "gpNo",
        "gpDate",
        "basePrice",
        "auctioneerValuation",
        "reservePrice",
        "priceIncrement",
        "markPackageComments",
        "lotComments",
        "qualityComments",
        "qualityCertification",
        "brewColor",
        "ageOfProducts",
        "brewersComments",
        "gardenCertification",
        "wareHouseName",
        "locationInsideWarehouse",
        "remarks",
        "lastModifiedBy",
        "marketTypeName",
        "SystemBasePrice",
        // "factoryId",
      ];
  const nonEditableColumns = [
    "KutchaCatalogId",
    "LotNo",
    "invoiceId",
    "invoiceNo",
    "origin",
    "teaTypeId",
    "teaTypeName",
    "subTeaTypeId",
    "subTeaTypeName",
    "categoryId",
    "categoryName",
    "markId",
    "markName",
    "sessionTypeId",
    "sessionTypeName",
    "gradeId",
    "gradeName",
    "packageType",
    "packageNo",
    "totalPackages",
    "grossKgs",
    "tareKgs",
    "netKgs",
    "invoiceWeight",
    "shortExcessWeight",
    "manufactureFromDate",
    "manufactureToDate",
    "gpNo",
    "gpDate",
    "wareHouseName",
    "lastModifiedBy",
    "marketTypeId",
    "marketTypeName",
    "SystemBasePrice",
  ]; // Add column names that are not editable

  useEffect(() => {
    dispatch(fetchMarkTypeRequest());
    // dispatch(fetchWarehouseUserRequest({ auctionCenterId }));

    //     dispatch(fetchSubTeaTypeRequest(formik.values.teaType));
  }, []);
  // console.log(data, selectedData, "checkedDatacheckedDatacheckedData");

  const markType = useSelector((state) => state.mark.markTypeData.responseData);
  function checkAllKeyValuesEmpty(arr) {
    return arr.reduce((acc, obj) => {
      for (let key in obj) {
        if (obj[key] === "") {
          return false;
        }
      }
      return acc;
    }, true);
  }

  const handleDragStart = (e, index) => {
    e.dataTransfer.setData("dragIndex", index);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDrop = (e, dropIndex) => {
    const dragIndex = e.dataTransfer.getData("dragIndex");
    const updatedColumns = [...columns];
    const draggedColumn = updatedColumns.splice(dragIndex, 1)[0];
    updatedColumns.splice(dropIndex, 0, draggedColumn);
    setColumns(updatedColumns);
  };

  const handleDragStart1 = (e, index) => {
    e.dataTransfer.setData("dragIndex", index);
  };

  const handleDragOver1 = (e) => {
    e.preventDefault();
  };

  const handleDrop1 = (e, dropIndex) => {
    const dragIndex = e.dataTransfer.getData("dragIndex");
    const updatedColumns = [...columnsOfKutchaAuctioner];
    const draggedColumn = updatedColumns.splice(dragIndex, 1)[0];
    updatedColumns.splice(dropIndex, 0, draggedColumn);
    setolumnsOfKutchaAuctioner(updatedColumns);
  };

  const columnExtensions = useMemo(() => [
    { columnName: "LotNo", editingEnabled: false },
    { columnName: "invoiceNo", editingEnabled: false },
    { columnName: "origin", editingEnabled: false },
    { columnName: "teaTypeName", editingEnabled: false },
    { columnName: "subTeaTypeName", editingEnabled: false },
    { columnName: "categoryName", editingEnabled: false },
    { columnName: "markName", editingEnabled: false },
    { columnName: "sessionTypeName", editingEnabled: false },
    { columnName: "gradeName", editingEnabled: false },
    { columnName: "packageType", editingEnabled: false },
    { columnName: "packageNo", editingEnabled: true },
    { columnName: "totalPackages", editingEnabled: true },
    { columnName: "SampleQty", editingEnabled: true },
    { columnName: "grossKgs", editingEnabled: true },
    { columnName: "tareKgs", editingEnabled: true },
    { columnName: "netKgs", editingEnabled: false },
    { columnName: "invoiceWeight", editingEnabled: false },
    { columnName: "shortExcessWeight", editingEnabled: true },
    { columnName: "manufactureFromDate", editingEnabled: false },
    { columnName: "manufactureToDate", editingEnabled: false },
    { columnName: "gpNo", editingEnabled: false },
    { columnName: "gpDate", editingEnabled: false },
    { columnName: "basePrice", editingEnabled: true },
    { columnName: "reservePrice", editingEnabled: true },
    { columnName: "auctioneerValuation", editingEnabled: true },
    { columnName: "markPackageComments", editingEnabled: true },
    { columnName: "lotComments", editingEnabled: true },
    { columnName: "qualityComments", editingEnabled: true },
    { columnName: "priceIncrement", editingEnabled: false },
    { columnName: "wareHouseName", editingEnabled: false },
    { columnName: "locationInsideWarehouse", editingEnabled: false },
    { columnName: "remarks", editingEnabled: true },
    { columnName: "lastModifiedBy", editingEnabled: false },
    { columnName: "lotType", editingEnabled: false },
    { columnName: "action", editingEnabled: false },
  ]);

  const handleCellClick = async (row, column) => {
    //debugger;
    try {
      openLoader();
      setauctioncatalogIdforupload(row.KutchaCatalogId);

      const apiUrl =
        `/preauction/EnglishAuctionKutchaCatalogue/GetKutchaCatalogValuationByParam?role=` +
        roleCode;

      const payload = {
        KutchaCatalogId: row.KutchaCatalogId,
        auctioneerId: userId,
        auctionCenterId: auctionCenterId,
        season: formik.values.season.toString(),
        saleNo: parseInt(formik.values.saleNo),
      };
      if (markTypeValue !== "0") {
        const response = await axiosMain.post(apiUrl, payload);
        // setGetDataByprems(response.data.responseData)
        return response.data.responseData;
      }
    } catch (error) {
      console.error("API error:", error);
    } finally {
      closeLoader();
    }
  };

  // const TableCell = useCallback(
  //   ({ row, column, ...restProps }) => (
  //     <Table.Cell
  //       {...restProps}
  //       onDoubleClick={() => handleCellClick(row, column)}
  //     />
  //   ),
  //   [handleCellClick]
  // );
  //on click cell each
  const validationSchema =
    roleCode === "buyer"
      ? Yup.object({
        // myValuation: Yup.string().required("My Valuation is required"),
        // myComments: Yup.string().required("My Comments is required"),
      })
      : baseUrlEng === "AuctionCatalog"
        ? Yup.object({
          basePrice: Yup.number()
            .positive("Base price should be greater than zero")
            .typeError("Base Price must be a number")
            .required("Please enter Base Price")
            .test(
              "twoDecimalPlaces",
              "Base Price cannot have decimal value",
              (value) => {
                if (typeof value !== "number") return true;
                const decimalPart = value.toString();
                return !decimalPart.includes(".");
              }
            ),
          priceIncrement: Yup.number().required("Please enter Price Increment"),
          gardenCertification: Yup.string().required(
            "Please enter Garden Certification"
          ),
          ageOfProducts: Yup.number().required(
            "Please enter Age of the Tea (In Months)"
          ),
          auctioneerValuation: Yup.number()
            .typeError("Auctioneer's Valuation must be a number")
            .required("Please enter Auctioneer's Valuation")
            .test(
              "twoDecimalPlaces",
              "Auctioneer Valuation cannot have decimal value",
              (value) => {
                if (typeof value !== "number") return true;
                // two dasimle value change in resever price auctioner valuaction and also baseprise if chnage in this
                // const decimalPart = value.toString().split(".")[1];
                // return !decimalPart || decimalPart.length <= 2;
                const decimalPart = value.toString();
                return !decimalPart.includes(".");
              }
            ),
          reservePrice: Yup.number()
            .typeError("Reserve Price must be a number")
            .test(
              "minBasePrice",
              "Reserve Price should always be greater than or equal to Base Price.",
              function (value) {
                const { basePrice } = this.parent;
                return basePrice === undefined || value >= basePrice;
              }
            )
            // .min(
            //   Yup.ref("basePrice"),
            //   "Reserve Price should always be greater than or equal to Base Price."
            // )
            .test(
              "twoDecimalPlaces",
              "Reserve price cannot have decimal value",
              (value) => {
                if (typeof value !== "number") return true;
                const decimalPart = value.toString();
                return !decimalPart.includes(".");
              }
            )
            .required("Please enter Reserve Price"),
          markPackageComments: Yup.string().max(
            255,
            "Mark & Packaging Comments must be 255 characters or less"
          ),
          lotComments: Yup.string().max(
            255,
            "Lot Comments must be 255 characters or less"
          ),
          grossKgs: Yup.number()
            .required("Please enter Gross Weight")
            .typeError("Gross Weight must be a number")
            .test(
              "twoDecimalPlaces",
              "Gross Weight must have at most two decimal places",
              (value) => {
                if (typeof value !== "number") return true;
                const decimalPart = value.toString().split(".")[1];
                return !decimalPart || decimalPart.length <= 2;
              }
            ),
          packageNo: Yup.string().matches(
            /^\d+-\d+$/,
            "Package No. must be in the format X-Y"
          ),
          sampleQty: Yup.number()
            .typeError("Sample Qty. must be a number")
            .test(
              "twoDecimalPlaces",
              "Sample Qty must have at most two decimal places",
              (value) => {
                if (typeof value !== "number") return true;
                const decimalPart = value.toString().split(".")[1];
                return !decimalPart || decimalPart.length <= 2;
              }
            ),
          // Add validation for other fields here
        })
        : baseUrlEng === "EnglishAuctionCatalog"
          ? Yup.object({
            //sessionTypeName: Yup.string().required("Please select Session Type"),
            basePrice: Yup.number()
              .positive("Base price should be greater than zero")
              .typeError("Base Price must be a number")
              .required("Please enter Base Price")
              .test(
                "twoDecimalPlaces",
                "Base Price cannot have decimal value",
                (value) => {
                  if (typeof value !== "number") return true;
                  const decimalPart = value.toString();
                  return !decimalPart.includes(".");
                }
              )
              .test(
                "maxBasePrice",
                "Base Price should always be less than or equal to Reserve Price.",
                function (value) {
                  const { reservePrice } = this.parent;
                  return reservePrice === undefined || value <= reservePrice;
                }
              ),
            // .max(
            //   Yup.ref("reservePrice"),
            //   "Base Price should always be less than or equal to Reserve Price."
            // )
            auctioneerValuation: Yup.number()
              .typeError("Auctioneer's Valuation must be a number")
              .required("Please enter Auctioneer's Valuation")
              .test(
                "twoDecimalPlaces",
                "Auctioneer Valuation cannot have decimal value",
                (value) => {
                  if (typeof value !== "number") return true;
                  const decimalPart = value.toString();
                  return !decimalPart.includes(".");
                }
              )
              .test(
                "maxReservePricePrice",
                "Auctioneer's Valuation should always be greater than or equal to Reserve Price.",
                function (value) {
                  const { reservePrice } = this.parent;
                  return reservePrice === undefined || value >= reservePrice;
                }
              ),
            // .min(
            //   Yup.ref("reservePrice"),
            //   "Auctioneer's Valuation should always be greater than or equal to Reserve Price."
            // )
            reservePrice: Yup.number()
              .typeError("Reserve Price must be a number")
              .test(
                "minBasePrice",
                "Reserve Price should always be greater than or equal to Base Price.",
                function (value) {
                  const { basePrice } = this.parent;
                  return basePrice === undefined || value >= basePrice;
                }
              )
              // .min(
              //   Yup.ref("basePrice"),
              //   "Reserve Price should always be greater than or equal to Base Price."
              // )
              .test(
                "twoDecimalPlaces",
                "Reserve price cannot have decimal value",
                (value) => {
                  if (typeof value !== "number") return true;
                  const decimalPart = value.toString();
                  return !decimalPart.includes(".");
                }
              )
              .required("Please enter Reserve Price"),
            markPackageComments: Yup.string().max(
              255,
              "Mark & Packaging Comments must be 255 characters or less"
            ),
            lotComments: Yup.string().max(
              255,
              "Lot Comments must be 255 characters or less"
            ),
            // grossWeight: Yup.number()
            //   .typeError("Gross Weight must be a number")
            //   .test(
            //     "twoDecimalPlaces",
            //     "Gross Weight must have at most two decimal places",
            //     (value) => {
            //       if (typeof value !== "number") return true;
            //       const decimalPart = value.toString().split(".")[1];
            //       return !decimalPart || decimalPart.length <= 2;
            //     }
            //   ),
            grossKgs: Yup.number()
              .required("Please enter Gross Weight")
              .typeError("Gross Weight must be a number")
              .test(
                "twoDecimalPlaces",
                "Gross Weight must have at most two decimal places",
                (value) => {
                  if (typeof value !== "number") return true;
                  const decimalPart = value.toString().split(".")[1];
                  return !decimalPart || decimalPart.length <= 2;
                }
              ),
            tareKgs: Yup.number()
              .typeError("Tare Weight must be a number")
              .test(
                "twoDecimalPlaces",
                "Tare  Weight must have at most two decimal places",
                (value) => {
                  if (typeof value !== "number") return true;
                  const decimalPart = value.toString().split(".")[1];
                  return !decimalPart || decimalPart.length <= 2;
                }
              ),
            packageNo: Yup.string().matches(
              /^\d+-\d+$/,
              "Package No. must be in the format X-Y"
            ),

            sampleQty: Yup.number()
              .typeError("Sample Qty. must be a number")
              .test(
                "twoDecimalPlaces",
                "Sample Qty must have at most two decimal places",
                (value) => {
                  if (typeof value !== "number") return true;
                  const decimalPart = value.toString().split(".")[1];
                  return !decimalPart || decimalPart.length <= 2;
                }
              ),
            // Add validation for other fields here
          })
          : baseUrlEng === "EnglishAuctionKutchaCatalogue"
            ? Yup.object({
              sessionTypeName: Yup.string().required("Please select Session Type"),
              basePrice: Yup.number()
                .nullable()
                .typeError("Base Price must be a number")
                // .positive("Base price should be greater than zero")
                .test(
                  "twoDecimalPlaces",
                  "Base Price cannot have decimal value",
                  (value) => {
                    if (value === null || value === undefined) return true;
                    return !value.toString().includes(".");
                  }
                )
                .test(
                  "maxBasePrice",
                  "Base Price should always be less than or equal to Reserve Price.",
                  function (value) {
                    const { reservePrice } = this.parent;
                    return reservePrice === undefined || value <= reservePrice;
                  }
                ),
              auctioneerValuation: Yup.number()
                .nullable()
                .typeError("Auctioneer's Valuation must be a number")
                .test(
                  "twoDecimalPlaces",
                  "Auctioneer Valuation cannot have decimal value",
                  (value) => {
                    if (value === null || value === undefined) return true;
                    return !value.toString().includes(".");
                  }
                )
                .test(
                  "maxReservePricePrice",
                  "Auctioneer's Valuation should always be greater than or equal to Reserve Price.",
                  function (value) {
                    const { reservePrice } = this.parent;
                    return reservePrice === undefined || value >= reservePrice;
                  }
                ),
              reservePrice: Yup.number()
                .nullable()
                .typeError("Reserve Price must be a number")
                .test(
                  "minBasePrice",
                  "Reserve Price should always be greater than or equal to Base Price.",
                  function (value) {
                    const { basePrice } = this.parent;
                    return basePrice === undefined || value >= basePrice;
                  }
                )
                .test(
                  "twoDecimalPlaces",
                  "Reserve price cannot have decimal value",
                  (value) => {
                    if (value === null || value === undefined) return true;
                    return !value.toString().includes(".");
                  }
                ),
              markPackageComments: Yup.string().max(
                255,
                "Mark & Packaging Comments must be 255 characters or less"
              )
              .nullable(),
              lotComments: Yup.string().max(
                255,
                "Lot Comments must be 255 characters or less"
              ).nullable(),
              grossKgs: Yup.number()
                .nullable()
                .typeError("Gross Weight must be a number")
                .test(
                  "twoDecimalPlaces",
                  "Gross Weight must have at most two decimal places",
                  (value) => {
                    if (value === null || value === undefined) return true;
                    const decimalPart = value?.toString().split(".")[1];
                    return !decimalPart || decimalPart.length <= 2;
                  }
                ),
              tareKgs: Yup.number()
                .nullable()
                .typeError("Tare Weight must be a number")
                .test(
                  "twoDecimalPlaces",
                  "Tare Weight must have at most two decimal places",
                  (value) => {
                    if (value === null || value === undefined) return true;
                    const decimalPart = value?.toString().split(".")[1];
                    return !decimalPart || decimalPart.length <= 2;
                  }
                ),
              packageNo: Yup.string().matches(
                /^\d+-\d+$/,
                "Package No. must be in the format X-Y"
              ),
              sampleQty: Yup.number()
                .nullable()
                .typeError("Sample Qty. must be a number")
                .test(
                  "twoDecimalPlaces",
                  "Sample Qty must have at most two decimal places",
                  (value) => {
                    if (value === null || value === undefined) return true;
                    const decimalPart = value?.toString().split(".")[1];
                    return !decimalPart || decimalPart.length <= 2;
                  }
                ),

              // sessionTypeName: Yup.string().required("Please select Session Type"),
              // basePrice: Yup.number()
              //   .positive("Base price should be greater than zero")
              //   .typeError("Base Price must be a number")
              //   .required("Please enter Base Price")
              //   .test(
              //     "twoDecimalPlaces",
              //     "Base Price cannot have decimal value",
              //     (value) => {
              //       if (typeof value !== "number") return true;
              //       const decimalPart = value.toString();
              //       return !decimalPart.includes(".");
              //     }
              //   )
              //   .test(
              //     "maxBasePrice",
              //     "Base Price should always be less than or equal to Reserve Price.",
              //     function (value) {
              //       const { reservePrice } = this.parent;
              //       return reservePrice !== undefined || value <= reservePrice;
              //     }
              //   ),
              // auctioneerValuation: Yup.number()
              //   .typeError("Auctioneer's Valuation must be a number")
              //   .required("Please enter Auctioneer's Valuation")
              //   .test(
              //     "twoDecimalPlaces",
              //     "Auctioneer Valuation cannot have decimal value",
              //     (value) => {
              //       if (typeof value !== "number") return true;
              //       const decimalPart = value.toString();
              //       return !decimalPart.includes(".");
              //     }
              //   )
              //   .test(
              //     "maxReservePricePrice",
              //     "Auctioneer's Valuation should always be greater than or equal to Reserve Price.",
              //     function (value) {
              //       const { reservePrice } = this.parent;
              //       return reservePrice === undefined || value >= reservePrice;
              //     }
              //   ),
              // reservePrice: Yup.number()
              //   .typeError("Reserve Price must be a number")
              //   .test(
              //     "minBasePrice",
              //     "Reserve Price should always be greater than or equal to Base Price.",
              //     function (value) {
              //       const { basePrice } = this.parent;
              //       return basePrice === undefined || value >= basePrice;
              //     }
              //   )
              //   .test(
              //     "twoDecimalPlaces",
              //     "Reserve price cannot have decimal value",
              //     (value) => {
              //       if (typeof value !== "number") return true;
              //       const decimalPart = value.toString();
              //       return !decimalPart.includes(".");
              //     }
              //   )
              //   .required("Please enter Reserve Price"),
              // markPackageComments: Yup.string().max(
              //   255,
              //   "Mark & Packaging Comments must be 255 characters or less"
              // ),
              // lotComments: Yup.string().max(
              //   255,
              //   "Lot Comments must be 255 characters or less"
              // ),
              // grossKgs: Yup.number()
              //   .required("Please enter Gross Weight")
              //   .typeError("Gross Weight must be a number")
              //   .test(
              //     "twoDecimalPlaces",
              //     "Gross Weight must have at most two decimal places",
              //     (value) => {
              //       if (typeof value !== "number") return true;
              //       const decimalPart = value.toString().split(".")[1];
              //       return !decimalPart || decimalPart.length <= 2;
              //     }
              //   ),
              // tareKgs: Yup.number()
              //   .typeError("Tare  Weight must be a number")
              //   .test(
              //     "twoDecimalPlaces",
              //     "Tare Weight must have at most two decimal places",
              //     (value) => {
              //       if (typeof value !== "number") return true;
              //       const decimalPart = value.toString().split(".")[1];
              //       return !decimalPart || decimalPart.length <= 2;
              //     }
              //   ),
              // packageNo: Yup.string().matches(
              //   /^\d+-\d+$/,
              //   "Package No. must be in the format X-Y"
              // ),

              // sampleQty: Yup.number()
              //   .typeError("Sample Qty. must be a number")
              //   .test(
              //     "twoDecimalPlaces",
              //     "Sample Qty must have at most two decimal places",
              //     (value) => {
              //       if (typeof value !== "number") return true;
              //       const decimalPart = value.toString().split(".")[1];
              //       return !decimalPart || decimalPart.length <= 2;
              //     }
              //   ),
              // Add validation for other fields here
            })
            : Yup.object({
              sessionTypeName: Yup.string().required("Please select Session Type"),
              basePrice: Yup.number()
                .positive("Base price should be greater than zero")
                .typeError("Base Price must be a number")
                .required("Please enter Base Price")
                .test(
                  "twoDecimalPlaces",
                  "Base Price cannot have decimal value",
                  (value) => {
                    if (typeof value !== "number") return true;
                    const decimalPart = value.toString();
                    return !decimalPart.includes(".");
                  }
                )
                .max(
                  Yup.ref("reservePrice"),
                  "Base Price should always be less than or equal to Reserve Price."
                ),
              auctioneerValuation: Yup.number()
                .typeError("Auctioneer's Valuation must be a number")
                .required("Please enter Auctioneer's Valuation")
                .test(
                  "twoDecimalPlaces",
                  "Auctioneer Valuation cannot have decimal value",
                  (value) => {
                    if (typeof value !== "number") return true;
                    const decimalPart = value.toString();
                    return !decimalPart.includes(".");
                  }
                ),
              reservePrice: Yup.number()
                .typeError("Reserve Price must be a number")
                .min(
                  Yup.ref("basePrice"),
                  "Reserve Price should always be greater than or equal to Base Price."
                )
                .test(
                  "twoDecimalPlaces",
                  "Reserve price cannot have decimal value",
                  (value) => {
                    if (typeof value !== "number") return true;
                    const decimalPart = value.toString();
                    return !decimalPart.includes(".");
                  }
                )
                .required("Please enter Reserve Price"),
              markPackageComments: Yup.string().max(
                255,
                "Mark & Packaging Comments must be 255 characters or less"
              ),
              lotComments: Yup.string().max(
                255,
                "Lot Comments must be 255 characters or less"
              ),
              // grossWeight: Yup.number()
              //   .typeError("Gross Weight must be a number")
              //   .test(
              //     "twoDecimalPlaces",
              //     "Gross Weight must have at most two decimal places",
              //     (value) => {
              //       if (typeof value !== "number") return true;
              //       const decimalPart = value.toString().split(".")[1];
              //       return !decimalPart || decimalPart.length <= 2;
              //     }
              //   ),
              grossKgs: Yup.number()
                .required("Please enter Gross Weight")
                .typeError("Gross Weight must be a number")
                .test(
                  "twoDecimalPlaces",
                  "Gross Weight must have at most two decimal places",
                  (value) => {
                    if (typeof value !== "number") return true;
                    const decimalPart = value.toString().split(".")[1];
                    return !decimalPart || decimalPart.length <= 2;
                  }
                ),
              tareKgs: Yup.number()
                .typeError("Tare Weight must be a number")
                .test(
                  "twoDecimalPlaces",
                  "Tare  Weight must have at most two decimal places",
                  (value) => {
                    if (typeof value !== "number") return true;
                    const decimalPart = value.toString().split(".")[1];
                    return !decimalPart || decimalPart.length <= 2;
                  }
                ),
              packageNo: Yup.string().matches(
                /^\d+-\d+$/,
                "Package No. must be in the format X-Y"
              ),

              sampleQty: Yup.number()
                .typeError("Sample Qty. must be a number")
                .test(
                  "twoDecimalPlaces",
                  "Sample Qty must have at most two decimal places",
                  (value) => {
                    if (typeof value !== "number") return true;
                    const decimalPart = value.toString().split(".")[1];
                    return !decimalPart || decimalPart.length <= 2;
                  }
                ),
              // Add validation for other fields here
            });

  const handleSelectRow = (KutchaCatalogId, LotNo) => {
    setSelectedRows((prev) => {
      const exists = prev.some(
        (row) => row.KutchaCatalogId === KutchaCatalogId
      );
      return exists
        ? prev.filter((row) => row.KutchaCatalogId !== KutchaCatalogId) // Remove if already selected
        : [...prev, { KutchaCatalogId, LotNo }]; // Add if not selected
    });
  };

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedRows([]); // Deselect all
    } else {
      setSelectedRows(
        data.map((row) => ({
          KutchaCatalogId: row.KutchaCatalogId,
          LotNo: row.LotNo,
        }))
      ); // Select all
    }
    setSelectAll(!selectAll);
  };

  const fnSubmitonClick = async (
    values,
    getDataByPrems,
    inputdata,
    MyCatalogId,
    valuationMap,
    index
  ) => {
    //debugger;
    if (
      (baseUrlEng === "EnglishAuctionCatalog" ||
        baseUrlEng === "EnglishAuctionKutchaCatalogue"
        ? getDataByPrems?.at(0)?.isEditable === 1
          ? true
          : false
        : //  getDataByPrems?.at(0)?.minute_difference >= 15
        // ? false
        // : true
        getDataByPrems?.at(0)?.minute_difference >= 15
          ? false
          : true) &&
      roleCode !== "buyer"
    ) {
      // onSubmit: (values, { resetForm }) => {
      openLoader();

      if (
        (baseUrlEng === "AuctionCatalog" &&
          getDataByPrems?.at(0)?.minute_difference >= 15 &&
          getDataByPrems?.at(0)?.hours_date_difference < 48) ||
        (baseUrlEng === "EnglishAuctionCatalog" &&
          // getDataByPrems?.at(0)?.minute_difference >= 15 &&
          getDataByPrems?.at(0)?.hours_date_difference < 24) ||
        (baseUrlEng === "EnglishAuctionKutchaCatalogue" &&
          // getDataByPrems?.at(0)?.minute_difference >= 15 &&
          getDataByPrems?.at(0)?.hours_date_difference < 24)
      ) {
        const {
          auctionCatalogId,
          SampleQty,
          basePrice,
          reservePrice,
          auctioneerValuation,
          priceIncrement,
          markPackageComments,
          lotComments,
          qualityComments,
          qualityCertification,
          brewColor,
          ageOfProducts,
          brewersComments,
          gardenCertification,
          netWeight,
          auctioneerId,
          saleNo,
          season,
          grossKgs,
          tareKgs,
        } = values;
        await axiosMain
          .post(
            baseUrlEng === "EnglishAuctionKutchaCatalogue"
              ? `/preauction/EnglishAuctionKutchaCatalogue/UpdateKutchaCatalogValuationReservePrice`
              : `/preauction/${baseUrlEng}/UpdateMyCatalogValuationReservePrice?role=` +
              roleCode,
            baseUrlEng === "AuctionCatalog" ||
              baseUrlEng === "EnglishAuctionKutchaCatalogue"
              ? {
                season: formik.values?.season?.toString(),
                saleNo: parseInt(formik.values?.saleNo),
                auctionCenterId,
                KutchaCatalogId: parseInt(
                  getDataByPrems?.at(0)?.KutchaCatalogId
                ),
                reservePrice,
                basePrice,
                auctioneerId: userId,

                //--ADDed
                // ageOfProducts: values.ageOfProducts,
                // gardenCertification: values.gardenCertification,
                // SaleProgramId: getDataByPrems[0]?.saleprogramid,

                // lotComments:
                //   lotComments === undefined ? null : lotComments,
                // markPackageComments:
                //   markPackageComments === undefined
                //     ? null
                //     : markPackageComments,
                // grossKgs,
                // tareKgs,
              }
              : {
                season: formik.values?.season,
                saleNo: parseInt(formik.values?.saleNo),
                auctionCenterId,
                KutchaCatalogId: parseInt(
                  getDataByPrems?.at(0)?.KutchaCatalogId
                ),
                reservePrice,
                auctioneerId: userId,
                ageOfProducts: values.ageOfProducts,
                gardenCertification: values.gardenCertification,
                SaleProgramId: getDataByPrems[0]?.saleprogramid,
                auctionCatalogId: getDataByPrems[0]?.auctionCatalogId,
              }
          )
          .then(async (res) => {
            if (res.data.statusCode === 403) {
              CustomToast.warning(res.data.message);
            } else if (res.data.statusCode === 200) {
              // CustomToast.success(res.data.message);
              setOpenUploadUpdateValuation(false);
              // resetForm();
              // if (baseUrlEng === "EnglishAuctionKutchaCatalogue") {
              //   // resetgetkuchacatalog();
              // } else {
              //   // resetgetmycatalog();
              // }
              // const updatedRows = data.map((row, index) =>
              //   changed[String(index)] ? { ...row, ...changed[String(index)] } : row
              // );
              // setData(updatedRows);

              const updatedRows = await data.map((row) => ({
                ...row,
                [valuationMap.name]:
                  valuationMap[row.KutchaCatalogId] ?? row[valuationMap.name], // Update only matching rows
              }));
              setData(updatedRows);

              setTimeout(() => {
                // //debugger;
                if (inputRefs.current[index + 1]) {
                  inputRefs.current[index + 1].focus();
                }
                if (selectRefs.current[index + 1]) {
                  selectRefs.current[index + 1].focus();
                }
              }, 1000);
              // setEditableCell({ rowId: data[index + 1].KutchaCatalogId, columnName: valuationMap.name });
              // setEditableCell({ rowId: null, columnName: null });
              // getkutcha();
            } else {
              CustomToast.error(res.data.message);
            }
            closeLoader();
            // setValuationMap({});
          })
          .catch((error) => {
            // CustomToast.error();
            closeLoader();
          });
      } else {
        values.auctioneerId = getDataByPrems?.at(0)?.auctioneerId;
        const {
          auctionCatalogId,
          SampleQty,
          basePrice,
          reservePrice,
          auctioneerValuation,
          priceIncrement,
          markPackageComments,
          lotComments,
          qualityComments,
          qualityCertification,
          brewColor,
          ageOfProducts,
          brewersComments,
          gardenCertification,
          netWeight,
          auctioneerId,
          grossKgs,
          tareKgs,
          sessionTypeName,
          remarks,
        } = values;
        await axiosMain
          .post(
            baseUrlEng === "EnglishAuctionKutchaCatalogue"
              ? `/preauction/${baseUrlEng}/UpdateKutchaCatalogueDetails?role=` +
              roleCode +
              "&flag=" +
              dataFlag +
              "&validateAction=submit&season=" +
              formik.values.season +
              "&saleNo=" +
              formik.values.saleNo
              : `/preauction/${baseUrlEng}/UploadValuation?role=` +
              roleCode +
              "&flag=" +
              dataFlag +
              "&validateAction=submit&season=" +
              formik.values.season +
              "&saleNo=" +
              formik.values.saleNo,
            // axios
            //   .post(
            //     "http://192.168.101.221:5080/preauction/AuctionCatalog/UploadValuation?role=" +
            //       userRole,
            // [{
            //   auctionCatalogId: auctionCatalogId,
            //   season: getDataByPrems[0]?.season,
            //   saleNo:
            //     getDataByPrems[0]?.saleNo !== "" ||
            //     getDataByPrems[0]?.saleNo !== 0
            //       ? parseInt(getDataByPrems[0]?.saleNo)
            //       : 0,
            //   SampleQty: SampleQty,
            //   basePrice: basePrice,
            //   reservePrice: reservePrice,
            //   auctioneerValuation: auctioneerValuation,
            //   priceIncrement: priceIncrement,
            //   markPackageComments: markPackageComments,
            //   lotComments: lotComments,
            //   qualityComments: qualityComments,
            //   qualityCertification: qualityCertification,
            //   brewColor: brewColor,
            //   ageOfProducts: ageOfProducts,
            //   brewersComments: brewersComments,
            //   gardenCertification: gardenCertification,
            //   netWeight: netWeight,
            //   auctioneerId: userId, //auctioner
            // }][
            baseUrlEng === "EnglishAuctionKutchaCatalogue"
              ? [
                {
                  KutchaCatalogId: getDataByPrems?.at(0)?.KutchaCatalogId,
                  invoiceId: getDataByPrems?.at(0)?.invoiceId,
                  saleNo: getDataByPrems?.at(0)?.saleNo,
                  locationInsideWarehouse:
                    getDataByPrems?.at(0)?.locationInsideWarehouse,
                  remarks: remarks, //getDataByPrems?.at(0)?.remarks,

                  // ageOfProducts:
                  //   ageOfProducts === undefined ? null : ageOfProducts,
                  auctioneerValuation:
                    auctioneerValuation === undefined
                      ? null
                      : auctioneerValuation,
                  basePrice: basePrice === undefined ? null : basePrice,
                  // brewersComments:
                  //   brewersComments === undefined ? null : brewersComments,
                  // brewColor: brewColor === undefined ? null : brewColor,
                  // gardenCertification:
                  //   gardenCertification === undefined
                  //     ? null
                  //     : gardenCertification,
                  lotComments: lotComments === undefined ? null : lotComments,
                  LotNo: getDataByPrems?.at(0)?.LotNo,
                  markPackageComments:
                    markPackageComments === undefined
                      ? null
                      : markPackageComments,
                  priceIncrement:
                    priceIncrement === undefined ||
                      priceIncrement === "" ||
                      priceIncrement === null
                      ? 1
                      : priceIncrement,
                  // // qualityCertification:
                  // //   qualityCertification === undefined
                  // //     ? null
                  // //     : qualityCertification,
                  qualityComments:
                    qualityComments === undefined ? null : qualityComments,
                  reservePrice: parseFloat(reservePrice),
                  SampleQty: SampleQty,
                  sessionTypeName: sessionTypeName,
                  // createdOn: null,
                  createdBy: userId, //auctioner
                  updatedBy: userId, //auctioner
                  // updatedOn: null,
                  status: 1,
                  auctionCenterId: auctionCenterId,
                  saleprogramid: saleProgramId?.at(0)?.SaleProgramId,

                  auctioneerId: userId,
                  auctionTypeMasterId: 2,
                  // markPackageComments,
                  // lotComments,
                  grossKgs,
                  tareKgs,
                  //new added
                  packageNo: values.packageNo, // getDataByPrems?.at(0)?.packageNo,
                  totalPackages: values.totalPackages, // getDataByPrems?.at(0)?.totalPackages,
                },
              ]
              : baseUrlEng === "AuctionCatalog"
                ? [
                  {
                    KutchaCatalogId: getDataByPrems?.at(0)?.KutchaCatalogId,
                    invoiceId: getDataByPrems?.at(0)?.invoiceId,
                    ageOfProducts:
                      ageOfProducts === undefined ? null : ageOfProducts,
                    auctioneerValuation:
                      auctioneerValuation === undefined
                        ? null
                        : auctioneerValuation,
                    basePrice: basePrice === undefined ? null : basePrice,
                    brewersComments:
                      brewersComments === undefined ? null : brewersComments,
                    brewColor: brewColor === undefined ? null : brewColor,
                    gardenCertification:
                      gardenCertification === undefined
                        ? null
                        : gardenCertification,
                    lotComments: lotComments === undefined ? null : lotComments,
                    LotNo: getDataByPrems?.at(0)?.LotNo,
                    markPackageComments:
                      markPackageComments === undefined
                        ? null
                        : markPackageComments,
                    priceIncrement:
                      priceIncrement === undefined ? null : priceIncrement,
                    qualityCertification:
                      qualityCertification === undefined
                        ? null
                        : qualityCertification,
                    qualityComments:
                      qualityComments === undefined ? null : qualityComments,
                    reservePrice: parseFloat(reservePrice),
                    SampleQty: SampleQty,
                    sessionType: getDataByPrems?.at(0)?.sessionType,
                    createdOn: null,
                    createdBy: userId, //auctioner
                    updatedBy: userId, //auctioner
                    updatedOn: null,
                    status: 1,
                    auctionCenterId: auctionCenterId,
                    saleprogramid: getDataByPrems?.at(0)?.saleprogramid,
                    grossKgs,
                    tareKgs,
                  },
                ]
                : [
                  {
                    sessionType: getDataByPrems?.at(0)?.sessionType,
                    KutchaCatalogId: getDataByPrems?.at(0)?.KutchaCatalogId,
                    invoiceId: getDataByPrems?.at(0)?.invoiceId,
                    saleNo: getDataByPrems?.at(0)?.saleNo,
                    locationInsideWarehouse:
                      getDataByPrems?.at(0)?.locationInsideWarehouse,
                    remarks: getDataByPrems?.at(0)?.remarks,
                    // ageOfProducts:
                    //   ageOfProducts === undefined ? null : ageOfProducts,
                    auctioneerValuation:
                      auctioneerValuation === undefined
                        ? null
                        : auctioneerValuation,
                    basePrice: basePrice === undefined ? null : basePrice,
                    // brewersComments:
                    //   brewersComments === undefined ? null : brewersComments,
                    // brewColor: brewColor === undefined ? null : brewColor,
                    // gardenCertification:
                    //   gardenCertification === undefined
                    //     ? null
                    //     : gardenCertification,
                    lotComments: lotComments === undefined ? null : lotComments,
                    LotNo: getDataByPrems?.at(0)?.LotNo,
                    markPackageComments:
                      markPackageComments === undefined
                        ? null
                        : markPackageComments,
                    priceIncrement:
                      priceIncrement === undefined ? null : priceIncrement,
                    // // qualityCertification:
                    // //   qualityCertification === undefined
                    // //     ? null
                    // //     : qualityCertification,
                    qualityComments:
                      qualityComments === undefined ? null : qualityComments,
                    reservePrice: parseFloat(reservePrice),
                    SampleQty: SampleQty,
                    // sessionTypeName: getDataByPrems?.at(0)?.sessionType,
                    createdOn: null,
                    createdBy: userId, //auctioner
                    updatedBy: userId, //auctioner
                    updatedOn: null,
                    status: 1,
                    auctionCenterId: auctionCenterId,
                    saleprogramid: getDataByPrems?.at(0)?.saleprogramid,

                    auctioneerId: userId,
                    auctionTypeMasterId: 2,
                    // markPackageComments,
                    // lotComments,
                    grossKgs,
                    tareKgs,
                    //new added
                    // packageNo: getDataByPrems?.at(0)?.packageNo,
                    // totalPackages: getDataByPrems?.at(0)?.totalPackages,
                    packageNo: values.packageNo, // getDataByPrems?.at(0)?.packageNo,
                    totalPackages: values.totalPackages, // getDataByPrems?.at(0)?.totalPackages,
                  },
                ]
          )
          .then((res) => {
            if (res.data.statusCode === 204) {
              CustomToast.warning(res.data.message);
            } else if (
              res.data.statusCode === 422 &&
              (baseUrlEng === "EnglishAuctionCatalog" ||
                baseUrlEng === "EnglishAuctionKutchaCatalogue")
            ) {
              // CustomToast.warning(response.data.message);
              setDataFlag(true);
              setOpenModalConformation(true);
              setOpenModalConformationTitle(res.data.message);
            } else if (res.data.statusCode === 200) {
              setOpenModalConformation(false);
              setDataFlag(false);
              // CustomToast.success(res.data.message);
              setOpenUploadUpdateValuation(false);

              // // resetForm();
              // if (baseUrlEng === "EnglishAuctionKutchaCatalogue") {
              //   // resetgetkuchacatalog();
              // } else {
              //   // resetgetmycatalog();
              // }
              const updatedRows = data.map((row) => ({
                ...row,
                [valuationMap.name]:
                  valuationMap[row.KutchaCatalogId] ?? row[valuationMap.name], // Update only matching rows
              }));
              setData(updatedRows);

              setTimeout(() => {
                // //debugger;
                if (inputRefs.current[index + 1]) {
                  inputRefs.current[index + 1].focus();
                }
                if (selectRefs.current[index + 1]) {
                  selectRefs.current[index + 1].focus();
                }
              }, 1000);
              // setEditableCell({ rowId: data[index + 1].KutchaCatalogId, columnName: valuationMap.name });
              // setEditableCell({ rowId: null, columnName: null });
              //getkutcha();
            } else if (res.data.statusCode === 403) {
              CustomToast.warning(res.data.message);
            } else {
              CustomToast.error(res.data.message);
            }
            // setValuationMap({});
            //setEditableCell({ rowId: null, columnName: null })
            closeLoader();
          })
          .catch((error) => {
            // CustomToast.error();
            closeLoader();
          });
      }

      // preventBlurRef.current = true;
    } else {
      CustomToast.warning("Do not allow Edit");
    }

    // },
  };
  const fnGetKutchaCatalogValuationByParam = (row) => {
    setOpenUploadUpdateValuation(true);
    setauctioncatalogIdforupload(
      row.KutchaCatalogId
    );
    openLoader();
    // debugger
    axiosMain
      .post(
        `/preauction/EnglishAuctionKutchaCatalogue/GetKutchaCatalogValuationByParam?role=` +
        roleCode,

        {
          KutchaCatalogId: row.KutchaCatalogId,
          auctioneerId: userId,
          auctionCenterId: auctionCenterId,
          season: formik.values.season.toString(),
          saleNo: parseInt(formik.values.saleNo),
        }
      )
      .then((res) => {
        setGetDataByprems(res.data.responseData);
        closeLoader();
      });
  }
  const commitChanges = async (
    row,
    inputdata,
    MyCatalogId,
    colName,
    data,
    index
  ) => {
    // if (!changed) return;
    // if (changed["0"] === undefined) return;

    // const changedIndex = Object.keys(changed)[0]; // Get the first changed row index
    // const updatedRow = { ...data[changedIndex], ...changed[changedIndex] };
    const updatedRow = { ...row, [colName]: inputdata };

    try {
      await validationSchema.validate(updatedRow, { abortEarly: false });

      let clickdata = await handleCellClick(updatedRow);

      fnSubmitonClick(
        updatedRow,
        clickdata,
        inputdata,
        MyCatalogId,
        {
          [MyCatalogId]: inputdata,
          name: colName,
        },
        index
      );

      // If validation succeeds, update the rows
    } catch (validationErrors) {
      CustomToast.error(validationErrors.inner?.at(0).errors?.at(0));
      // console.error("Validation errors:", validationErrors.inner);
      // Handle validation errors (e.g., show in UI)
    }
  };
  const handleRowClickchangeColor = (index) => {
    setRowcolorChange(index);
  };

  return (
    <div>
      {auctionType === "ENGLISH" ? (
        <>
          {" "}
          {/* <div>Total Count : {data?.length}</div> */}
          <div
            style={{
              overflowX: "auto",
              overflowY: "auto",
              maxHeight: "400px",
              maxWidth: "100%",
              border: "1px solid #ccc",
              whiteSpace: "nowrap",
            }}
            className="TableBox normal-table"
            ref={tableRef}
          >
            <table
              // ref={tableRef}
              className="resizable-columns-table"
              style={{
                borderCollapse: "collapse",
                width: "100%",
                minWidth: "600px",
              }}
            >
              <thead>
                <tr>
                  {status?.toString() !== "0" && (
                    <th
                      style={{
                        position: "sticky",
                        left: 0,
                        background: "#fff",
                        zIndex: 10,
                        borderRight: "1px solid #ddd",
                        padding: "10px",
                        resize: "none",
                        width: "35px",
                      }}
                    >
                      {" "}
                      <input
                        type="checkbox"
                        checked={selectAll}
                        onChange={handleSelectAll}
                      />
                    </th>
                  )}
                  <th
                    style={{
                      position: "sticky",
                      left: status?.toString() === "0" ? "0px" : "30px",
                      background: "#fff",
                      zIndex: 10,
                      borderRight: "1px solid #ddd",
                      padding: "10px",
                      resize: "none",
                      width: "340px",
                    }}
                  >
                    Lot No.
                  </th>

                  {columnsOfKutchaAuctioner
                    ?.filter((col) =>
                      status?.toString() !== "0"
                        ? col.name
                        : col.name !== "action"
                    )
                    .map((col, index) => (
                      <th
                        // key={index}
                        draggable
                        onDragStart={(e) => handleDragStart1(e, index)}
                        onDragOver={handleDragOver1}
                        onDrop={(e) => handleDrop1(e, index)}
                        key={col.name}
                      >
                        {col.title}
                      </th>
                    ))}
                </tr>
              </thead>
              <tbody>
                {data.length > 0 ? (
                  data.map((row, index) => (
                    <tr onDoubleClick={() => fnGetKutchaCatalogValuationByParam(row)}
                      key={row.KutchaCatalogId}
                      // style={{
                      //   backgroundColor: selectedRows.includes(
                      //     row.KutchaCatalogId
                      //   )
                      //     ? "#f0f0f0"
                      //     : "transparent",
                      // }}
                      onClick={() => handleRowClickchangeColor(index)}
                      style={{
                        backgroundColor:
                          rowColorchange === index ? "#f0f0f0" : "transparent",
                        cursor: "pointer",
                      }}
                    >
                      {status?.toString() !== "0" && (
                        <td
                          style={{
                            position: "sticky",
                            left: 0,
                            background: "#f0f0f0",
                            zIndex: 10,
                            borderRight: "1px solid #ddd",
                            // padding: "10px",
                            paddingLeft: "9px",
                          }}
                        >
                          <input
                            type="checkbox"
                            checked={selectedRows.some(
                              (roww) =>
                                roww.KutchaCatalogId === row.KutchaCatalogId
                            )}
                            onChange={() => {
                              handleSelectRow(row.KutchaCatalogId, row.LotNo);
                              handleRowClickchangeColor(index);
                            }}
                          />
                        </td>
                      )}
                      <td
                        style={{
                          position: "sticky",
                          left: status?.toString() === "0" ? "0px" : "30px",
                          background: "#f0f0f0",
                          zIndex: 10,
                          borderRight: "1px solid #ddd",
                          padding: "10px",
                          resize: "none",
                          width: "340px",
                        }}
                      >
                        {row.LotNo}
                      </td>
                      {columnsOfKutchaAuctioner?.map((col) => (
                        <td
                          key={col.name}
                          onClick={() =>
                            setEditableCell({
                              rowId: row.KutchaCatalogId,
                              columnName: col.name,
                            })
                          }
                        >
                          {[
                            "auctioneerValuation",
                            "grossKgs",
                            "basePrice",
                            "reservePrice",
                            "SampleQty",
                            "totalPackages",
                            "tareKgs",
                          ].includes(col.name) && status?.toString() !== "0" ? (
                            editableCell.rowId === row.KutchaCatalogId &&
                              editableCell.columnName === col.name ? (
                              <input
                                ref={(el) => (inputRefs.current[index] = el)}
                                type="number"
                                autoFocus
                                defaultValue={row[col.name] ?? ""}
                                // onBlur={() => {
                                //   // if (!preventBlurRef.current) {
                                //   setEditableCell({
                                //     rowId: null,
                                //     columnName: null,
                                //   });
                                //   // } else {
                                //   //   preventBlurRef.current = false; // Reset flag
                                //   // }
                                // }}
                                onKeyDown={async (e) => {
                                  if (e.key === "Enter") {
                                    e.preventDefault(); // Prevent form submission and blur

                                    // preventBlurRef.current = true; // Temporarily prevent blur

                                    try {
                                      // Find current row index
                                      const currentIndex = rows.findIndex(
                                        (r) =>
                                          r.KutchaCatalogId ===
                                          row.KutchaCatalogId
                                      );

                                      // Move focus to the next row in the same column if possible
                                      // if (currentIndex !== -1 && currentIndex < rows.length - 1) {
                                      //   const nextRow = rows[currentIndex + 1];

                                      //   setTimeout(() => {
                                      //     inputRefs.current[nextRow.KutchaCatalogId]?.focus(); // Focus next input
                                      //   }, 0);
                                      // }
                                      setEditableCell({
                                        rowId: data[index + 1].KutchaCatalogId,
                                        columnName: col.name,
                                      });
                                      await commitChanges(
                                        row,
                                        e.target.value,
                                        row.KutchaCatalogId,
                                        col.name,
                                        data,
                                        index
                                      );
                                    } catch (error) {
                                      // preventBlurRef.current = true;
                                      console.error(
                                        "Error in commitChanges:",
                                        error
                                      );
                                    }
                                  }
                                }}
                                disabled={
                                  row?.isEditable === 0
                                    ? true
                                    : row?.hours_date_difference < 24 &&
                                      col.name === "reservePrice"
                                      ? false
                                      : row?.hours_date_difference < 24
                                }
                                onFocus={(e) => (e.target.value = "")}
                              />
                            ) : (
                              <span>{row[col.name] ?? "-"}</span>
                            )
                          ) : [
                            "markPackageComments",
                            "lotComments",
                            "packageNo",
                            "qualityComments",
                            // "gardenCertification",
                            // "qualityCertification",
                            // "brewColor",
                            // "brewersComments",
                            // "categoryName",
                            "shortExcessWeight",
                            "remarks",
                          ].includes(col.name) &&
                            status?.toString() !== "0" ? (
                            editableCell.rowId === row.KutchaCatalogId &&
                              editableCell.columnName === col.name ? (
                              <input
                                ref={(el) =>
                                  (inputRefs.current[row.KutchaCatalogId] = el)
                                }
                                type="text"
                                autoFocus
                                defaultValue={row[col.name] ?? ""}
                                // onBlur={() => {
                                //   setEditableCell({
                                //     rowId: null,
                                //     columnName: null,
                                //   });
                                // }}
                                onKeyDown={(e) => {
                                  if (e.key === "Enter") {
                                    setEditableCell({
                                      rowId: data[index + 1].KutchaCatalogId,
                                      columnName: col.name,
                                    });
                                    commitChanges(
                                      row,
                                      e.target.value,
                                      row.KutchaCatalogId,
                                      col.name,
                                      index
                                    );
                                  }
                                }}
                                disabled={
                                  row?.isEditable === 0
                                    ? true
                                    : row?.hours_date_difference < 24 &&
                                      col.name === "reservePrice"
                                      ? false
                                      : row?.hours_date_difference < 24
                                }
                                onFocus={(e) => (e.target.value = "")}
                              />
                            ) : (
                              <span>{row[col.name] ?? "-"}</span>
                            )
                          ) : col.name === "sessionTypeName" &&
                            status?.toString() !== "0" ? (
                            editableCell.rowId === row.KutchaCatalogId &&
                              editableCell.columnName === col.name ? (
                              <select
                                defaultValue={row.sessionTypeName || ""}
                                ref={(el) => (selectRefs.current[index] = el)}
                                onKeyDown={(e) => {
                                  if (e.key === "Enter") {
                                    setEditableCell({
                                      rowId: data[index + 1].KutchaCatalogId,
                                      columnName: col.name,
                                    });

                                    commitChanges(
                                      row,
                                      e.target.value,
                                      row.KutchaCatalogId,
                                      col.name,
                                      index
                                    );
                                  }
                                }}
                                // onChange={(e) => {
                                //   if (
                                //     row?.isEditable === 0
                                //       ? true
                                //       : row?.hours_date_difference < 24 &&
                                //         col.name === "reservePrice"
                                //       ? false
                                //       : row?.hours_date_difference < 24
                                //   ) {
                                //     return;
                                //   } else
                                //     commitChanges(
                                //       row,
                                //       e.target.value,
                                //       row.KutchaCatalogId,
                                //       col.name
                                //     );
                                // }}
                                disabled={
                                  row?.isEditable === 0
                                    ? true
                                    : row?.hours_date_difference < 24 &&
                                      col.name === "reservePrice"
                                      ? false
                                      : row?.hours_date_difference < 24
                                }
                              >
                                {/* {groupCode.map((group) => (
                                      <option key={group.groupId} value={group.groupCode}>
                                        {group.groupCode}
                                      </option>
                                    ))} */}
                                <option value="">Select Session type</option>
                                {sessiontyp?.map((item) => (
                                  <option value={item.sessionTypeName}>
                                    {item.sessionTypeName}
                                  </option>
                                ))}
                              </select>
                            ) : (
                              <span>{row.sessionTypeName ?? "-"}</span>
                            )
                          ) : col.name === "action" &&
                            status?.toString() !== "0" ? (
                            <>
                              <button
                                type="button"
                                onClick={() => fnGetKutchaCatalogValuationByParam(row)}
                              >
                                <i class="fa fa-edit"></i>
                              </button>
                            </>
                          ) : row[col.name] === null ? (
                            "-"
                          ) : (
                            row[col.name]
                          )}
                        </td>
                      ))}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={53}>
                      <div className="NoData">No Records Found</div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </>
      ) : (
        <>
          <div
            style={{
              overflowX: "auto",
              overflowY: "auto",
              maxHeight: "400px",
              maxWidth: "100%",
              border: "1px solid #ccc",
              whiteSpace: "nowrap",
            }}
            className="TableBox normal-table"
          >
            <table
              className="resizable-columns-table"
              style={{
                borderCollapse: "collapse",
                width: "100%",
                minWidth: "600px",
              }}
            >
              <thead>
                <tr>
                  {status?.toString() === "0" ? (
                    ""
                  ) : (
                    <th
                      style={{
                        position: "sticky",
                        left: 0,
                        background: "#fff",
                        zIndex: 10,
                        borderRight: "1px solid #ddd",
                        padding: "10px",
                        resize: "none",
                        width: "35px",
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={
                          rows.length > 0
                            ? selectedData.length === rows.length
                            : false
                        }
                        onChange={() => {
                          setAllChacked(!allCheked);

                          if (selectedData.length === rows.length) {
                            setSelectedData([]);
                          } else {
                            setSelectedData(rows);
                          }
                        }}
                      />
                    </th>
                  )}
                  <th
                    style={{
                      position: "sticky",
                      left: status?.toString() === "0" ? "0px" : "30px",
                      background: "#fff",
                      zIndex: 10,
                      borderRight: "1px solid #ddd",
                      padding: "10px",
                      resize: "none",
                      width: "340px",
                    }}
                  >
                    Lot No.
                  </th>
                  {columns
                    // .filter((item) => item.id !== "LotNo")
                    .map((column, index) => (
                      <th
                        key={index}
                        draggable
                        onDragStart={(e) => handleDragStart(e, index)}
                        onDragOver={handleDragOver}
                        onDrop={(e) => handleDrop(e, index)}
                      // style={{ width: column.width }}
                      >
                        <div className="resizable-columns">
                          <span>{column.label}</span>
                        </div>
                      </th>
                    ))}
                </tr>
              </thead>
              <tbody>
                {data?.length > 0 ? (
                  data?.map((item, index) => (
                    // auctionType === "ENGLISH" ? (
                    //   <tr key={item.KutchaCatalogId}>
                    //     {propertyNames.map((propertyName) => (
                    //       <td>{item[propertyName]}</td>
                    //     ))}
                    //   </tr>
                    // ) :
                    <tr
                      onClick={() => {
                        newhandleCheckboxChange(item.KutchaCatalogId);
                        handleRowClickchangeColor(index);
                      }}
                      key={item.KutchaCatalogId}
                      // style={{
                      //   backgroundColor: selectedRows.includes(
                      //     item.KutchaCatalogId
                      //   )
                      //     ? "#f0f0f0"
                      //     : "transparent",
                      // }}
                      // onClick={() => handleRowClickchangeColor(item)}
                      style={{
                        backgroundColor:
                          rowColorchange === index ? "#f0f0f0" : "transparent",
                        cursor: "pointer",
                      }}
                    >
                      {status === "0" ? (
                        ""
                      ) : status?.toString() === "0" ? (
                        ""
                      ) : (
                        <td
                          style={{
                            position: "sticky",
                            left: 0,
                            background: "#f0f0f0",
                            zIndex: 10,
                            borderRight: "1px solid #ddd",
                            // padding: "10px",
                            paddingLeft: "9px",
                          }}
                        >
                          <input
                            type="checkbox"
                            checked={selectedData.some(
                              (selectedItem) =>
                                selectedItem.KutchaCatalogId ===
                                item.KutchaCatalogId
                            )}
                            onChange={() => {
                              setChecked(!checked);
                              handleCheckboxChange(item.KutchaCatalogId);
                            }}
                          />
                        </td>
                      )}
                      <td
                        style={{
                          position: "sticky",
                          left: status?.toString() === "0" ? "0px" : "30px",
                          background: "#f0f0f0",
                          zIndex: 10,
                          borderRight: "1px solid #ddd",
                          padding: "10px",
                          resize: "none",
                          width: "340px",
                        }}
                      >
                        {item.LotNo}
                      </td>
                      {columns
                        .filter((ele) =>
                          auctionType !== "ENGLISH"
                            ? ele.id
                            : ele.id === "qualityCertification" &&
                            ele.id === "priceIncrement" &&
                            ele.id === "brewColor" &&
                            ele.id === "ageOfProducts" &&
                            ele.id === "brewersComments" &&
                            ele.id === "gardenCertification"
                        )
                        .map((propertyName) => (
                          <td
                            key={`${item.KutchaCatalogId}-${propertyName.id}`}
                          >
                            {nonEditableColumns
                              .filter((ele) =>
                                auctionType !== "ENGLISH"
                                  ? ele
                                  : ele === "qualityCertification" &&
                                  ele === "priceIncrement" &&
                                  ele === "brewColor" &&
                                  ele === "ageOfProducts" &&
                                  ele === "brewersComments" &&
                                  ele === "gardenCertification"
                              )
                              .includes(propertyName.id) ? (
                              item[propertyName.id] === null ? (
                                "-"
                              ) : (
                                item[propertyName.id]
                              )
                            ) : //propertyName.id === "priceIncrement" &&
                              //   selectedData.some(
                              //     (obj) =>
                              //       obj.KutchaCatalogId === item.KutchaCatalogId
                              //   ) ? (
                              //   editing ? (
                              //     <input
                              //       type="textarea"
                              //       value={item[propertyName.id]}
                              //       onChange={(e) =>
                              //         handleSaveCell(           F
                              //           item.KutchaCatalogId,
                              //           propertyName.id,
                              //           e.target.value
                              //         )
                              //       }
                              //       maxLength={5}
                              //     />
                              //   ) : (
                              //     item[propertyName.id]
                              //   )
                              // ) :
                              propertyName.id === "gpDate" &&
                                item?.gpDate !== null ? (
                                item?.gpDate
                              ) : propertyName.id === "gpDate" &&
                                selectedData.some(
                                  (obj) =>
                                    obj.KutchaCatalogId === item.KutchaCatalogId
                                ) ? (
                                editing ? (
                                  <input
                                    type="date"
                                    value={item[propertyName.id]}
                                    onChange={(e) =>
                                      handleSaveCell(
                                        item.KutchaCatalogId,
                                        propertyName.id,
                                        e.target.value
                                      )
                                    }
                                  />
                                ) : (
                                  item[propertyName.id]
                                )
                              ) : editing &&
                                propertyName.id === "MarketType" &&
                                selectedData.some(
                                  (obj) =>
                                    obj.KutchaCatalogId === item.KutchaCatalogId
                                ) ? (
                                <select
                                  value={item[propertyName.id]}
                                  onChange={(e) =>
                                    handleSaveCell(
                                      item.KutchaCatalogId,
                                      propertyName.id,
                                      e.target.value
                                    )
                                  }
                                >
                                  {markType?.length > 0 ? (
                                    markType?.map((item, index) => (
                                      <option
                                        value={item.marketTypeId}
                                        key={index}
                                      >
                                        {item.marketTypeName}
                                      </option>
                                    ))
                                  ) : (
                                    <option>No Data</option>
                                  )}
                                </select>
                              ) : editing &&
                                propertyName.id === "subTeaTypeId" &&
                                selectedData.some(
                                  (obj) =>
                                    obj.KutchaCatalogId === item.KutchaCatalogId
                                ) ? (
                                <select
                                  value={item[propertyName.id]}
                                  onChange={(e) =>
                                    handleSaveCell(
                                      item.KutchaCatalogId,
                                      propertyName.id,
                                      e.target.value
                                    )
                                  }
                                >
                                  <option value="1">Option 1</option>
                                  <option value="2">Option 2</option>
                                  <option value="3">Option 3</option>
                                </select>
                              ) : editing &&
                                selectedData.some(
                                  (obj) =>
                                    obj.KutchaCatalogId === item.KutchaCatalogId
                                ) ? (
                                <>
                                  <input
                                    type={
                                      [
                                        "markPackageComments",
                                        "lotComments",
                                        "qualityComments",
                                        "qualityCertification",
                                        "brewColor",
                                        // "ageOfProducts",
                                        "brewersComments",
                                        "gardenCertification",
                                        "locationInsideWarehouse",
                                        "remarks",
                                        "lastModifiedBy",
                                      ]?.includes(propertyName.id)
                                        ? "text"
                                        : "number"
                                    }
                                    value={item[propertyName.id]}
                                    onChange={(e) =>
                                      handleSaveCell(
                                        item.KutchaCatalogId,
                                        propertyName.id,
                                        e.target.value
                                      )
                                    }
                                  />
                                  {validationErrors?.length > 0
                                    ? validationErrors?.find(
                                      (ele) =>
                                        item.KutchaCatalogId === ele?.id &&
                                        Object.keys(item)?.includes(
                                          propertyName.id
                                        )
                                    )?.[propertyName.id] && (
                                      <div className="ValidationError text-danger">
                                        {
                                          validationErrors?.find(
                                            (ele) =>
                                              item.KutchaCatalogId ===
                                              ele?.id &&
                                              Object.keys(item)?.includes(
                                                propertyName.id
                                              )
                                          )[propertyName.id]
                                        }
                                      </div>
                                    )
                                    : ""}
                                </>
                              ) : //: propertyName.id === "SystemBasePrice" ? (
                                //   10
                                // )
                                item[propertyName.id] === null ? (
                                  "-"
                                ) : propertyName.id === "wareHouseName" ? (
                                  item[propertyName.id]
                                ) : (
                                  item[propertyName.id]
                                )}
                          </td>
                        ))}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={53}>
                      <div className="NoData" style={{ fontSize: "12px" }}>
                        No Records Found
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* <div className="text-end">
            <Pagination
              count={rows.length}
              variant="outlined"
              shape="rounded"
              onChange={handleChangePage}
            />
          </div> */}
        </>
      )}

      <div className="row">
        <div className="col-12">
          <div className="BtnGroup">
            {baseUrlEng === "EnglishAuctionKutchaCatalogue" &&
              selectedRows?.length > 0 &&
              status?.toString() !== "0" ? (
              <button
                disabled={selectedRows?.length > 0 ? false : true}
                className="SubmitBtn"
                onClick={() => setOpenDelete(true)}
              >
                Remove
              </button>
            ) : selectedData?.length > 0 && status?.toString() !== "0" ? (
              <button
                disabled={selectedData?.length > 0 ? false : true}
                className="SubmitBtn"
                onClick={() => setOpenDelete(true)}
              >
                Remove
              </button>
            ) : (
              ""
            )}

            {rows?.length > 0 ? (
              editing && selectedData.length > 0 ? (
                <button
                  onClick={() => {
                    const updatedData = selectedData.map((ele) => {
                      let data = {
                        KutchaCatalogId: ele.KutchaCatalogId,
                        SampleQty: parseFloat(ele.SampleQty),
                        basePrice: parseFloat(ele.basePrice),
                        reservePrice: parseFloat(ele.reservePrice),
                        auctioneerValuation: parseFloat(
                          ele.auctioneerValuation
                        ),
                        priceIncrement: parseFloat(ele.priceIncrement),
                        markPackageComments: ele.markPackageComments,
                        lotComments: ele.lotComments,
                        qualityComments: ele.qualityComments,
                        qualityCertification: ele.qualityCertification,
                        brewColor: ele.brewColor,
                        ageOfProducts: parseFloat(ele.ageOfProducts),
                        brewersComments: ele.brewersComments,
                        gardenCertification: ele.gardenCertification,
                        locationInsideWarehouse: ele.locationInsideWarehouse,
                        remarks: ele.remarks,
                        SystemBasePrice: parseFloat(ele.SystemBasePrice),
                        updatedBy: userId, //auctioner
                        auctionCenterId: auctionCenterId,
                        saleProgramId: saleProgramId?.at(0)?.SaleProgramId,
                        LotNo: ele.LotNo,
                      };
                      return data;
                    });

                    console.log(
                      // updatedData.some((ele) => isNaN(ele.SampleQty)),
                      // updatedData.map((ele) =>
                      //   isNaN(ele.SampleQty)
                      //     ? CustomToast.warning("Please Enter sample qty")
                      //     : ""
                      // ),
                      validationErrors,
                      checkAllKeyValuesEmpty(validationErrors),
                      updatedData.map((ele) => isNaN(ele.SampleQty)),
                      "updatedDataupdatedData"
                    );
                    if (updatedData.some((ele) => isNaN(ele.SampleQty))) {
                      CustomToast.warning("Please Enter sample qty");
                    } else {
                      if (
                        updatedData.some(
                          (ele) =>
                            ele.gardenCertification === "" ||
                            ele.gardenCertification === null
                        )
                      ) {
                        const garden = updatedData
                          .map(
                            (ele, index) =>
                              (ele.gardenCertification === "" ||
                                ele.gardenCertification === null) &&
                              index + 1
                          )
                          .join(",");
                        CustomToast.warning(
                          "Please Enter Garden Certification in Row No. " +
                          garden
                        );
                      } else if (
                        updatedData.some(
                          (ele) =>
                            ele.brewColor !== "" &&
                            ele.brewColor !== null &&
                            ele.brewColor !== undefined &&
                            !/^[a-zA-Z0-9 ]{1,100}$/.test(ele.brewColor)
                        )
                      ) {
                        const brewColorspecial = updatedData
                          .map((ele, index) => {
                            // Check if brew is empty, null, or contains special characters
                            const isInvalidBrew = !/^[a-zA-Z0-9 ]{1,100}$/.test(
                              ele.brewColor
                            );
                            // Return the index (1-based) if the brew is invalid, otherwise return null
                            return isInvalidBrew ? index + 1 : null;
                          })
                          .filter((index) => index !== null) // Filter out the null values
                          .join(",");
                        CustomToast.error(
                          "The length of Brew color 100 alpha numeric. It should not allow special characters in Row No. " +
                          brewColorspecial
                        );
                      } else if (
                        updatedData.some(
                          (ele) =>
                            ele.brewColor !== "" &&
                            ele.brewColor !== null &&
                            ele.brewColor !== undefined &&
                            !(ele.brewColor.length <= 100)
                        )
                      ) {
                        const brewColorlen = updatedData
                          .map((ele, index) => {
                            // Check if brew is empty, null, or contains special characters
                            const isInvalidBrew = !(
                              ele.brewColor.length <= 100
                            );
                            // Return the index (1-based) if the brew is invalid, otherwise return null
                            return isInvalidBrew ? index + 1 : null;
                          })
                          .filter((index) => index !== null) // Filter out the null values
                          .join(",");
                        CustomToast.error(
                          "Brew color length of the field 100 alpha numeric in Row No. " +
                          brewColorlen
                        );
                      } else if (
                        updatedData.some(
                          (ele) =>
                            ele.qualityCertification !== "" &&
                            ele.qualityCertification !== null &&
                            ele.qualityCertification !== undefined &&
                            !(ele.qualityCertification.length <= 500)
                        )
                      ) {
                        const qualitycerlen = updatedData
                          .map((ele, index) => {
                            // Check if brew is empty, null, or contains special characters
                            const isInvalidBrew = !(
                              ele.qualityCertification.length <= 500
                            );
                            // Return the index (1-based) if the brew is invalid, otherwise return null
                            return isInvalidBrew ? index + 1 : null;
                          })
                          .filter((index) => index !== null) // Filter out the null values
                          .join(",");
                        CustomToast.error(
                          "Quality Certification length of the field 500 alpha numeric in Row No. " +
                          qualitycerlen
                        );
                      } else if (
                        updatedData.some(
                          (ele) =>
                            (ele.gardenCertification !== "" ||
                              ele.gardenCertification !== null ||
                              ele.gardenCertification !== undefined) &&
                            !(ele.gardenCertification.length <= 500)
                        )
                      ) {
                        const gardencerlen = updatedData
                          .map((ele, index) => {
                            // Check if brew is empty, null, or contains special characters
                            const isInvalidBrew = !(
                              ele.gardenCertification.length <= 500
                            );
                            // Return the index (1-based) if the brew is invalid, otherwise return null
                            return isInvalidBrew ? index + 1 : null;
                          })
                          .filter((index) => index !== null) // Filter out the null values
                          .join(",");
                        CustomToast.error(
                          "The length of Garden Certification 500 alpha numeric. It should allow special characters  ‘&’,’-‘.. in Row No. " +
                          gardencerlen
                        );
                      } else if (validationErrors?.length > 0) {
                        CustomToast.error("Please Enter apropriate value.");
                      } else {
                        openLoader();
                        axiosMain
                          .post(
                            `/preauction/${baseUrlEng}/UpdateKutchaCatalogueDetails?season=` +
                            formik.values.season +
                            "&saleNo=" +
                            formik.values.saleNo,
                            updatedData
                          )
                          .then((res) => {
                            if (res.data.statusCode === 200) {
                              CustomToast.success(res.data.message);
                              handleEditToggle();
                              setSelectedData([]);
                              getkutcha();
                            } else {
                              CustomToast.error(res.data.message);
                            }
                            closeLoader();
                          })
                          .catch(({ errors }) => {
                            closeLoader();
                            CustomToast.error(errors.data.message);
                          });
                      }
                    }

                    // console.log(data, updatedData, "datadata");
                  }}
                  className="SubmitBtn"
                >
                  Save Changes
                </button>
              ) : auctionType === "ENGLISH" ? (
                ""
              ) : (
                status?.toString() === "1" &&
                modalRight?.includes("1") && (
                  <button
                    className="SubmitBtn"
                    onClick={() => {
                      if (selectedData.length > 0) {
                        handleEditToggle();
                      } else {
                        CustomToast.warning(
                          "Please select one or more row to edit that row"
                        );
                      }
                    }}
                  >
                    Edit
                  </button>
                )
              )
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
      <ConfirmationModal
        show={openDelete}
        title={
          baseUrlEng === "KutchaCatalogue"
            ? "Are you sure you want to remove this lot(" +
            selectedData.map((ele) => ele.LotNo).join(", ") +
            ")?"
            : "Are you sure you want to remove this lot(" +
            selectedRows?.map((ele, index) => ele?.LotNo).join(", ") +
            ")?"
        }
        isokbutton={"YesNo"}
        onDelete={async () => {
          if (data?.length > 0) {
            try {
              openLoader();
              var sdata =
                baseUrlEng === "KutchaCatalogue"
                  ? selectedData.map((ele) => ele.KutchaCatalogId).join(", ")
                  : selectedRows
                    ?.map((ele, index) => ele?.KutchaCatalogId)
                    .join(", ");
              //debugger;
              const idsToSlice = sdata.split(",").map((id) => parseInt(id)); // Split and convert to integers
              // Call handleSliceData with the IDs to slice

              const response = await axiosMain.post(
                `/preauction/${baseUrlEng}/DeleteKutchaCatalogueDetails?role=${roleCode}`,
                {
                  season: data?.at(0)?.season,
                  saleNo: data?.at(0)?.saleNo,
                  KutchaCatalogIds:
                    baseUrlEng === "KutchaCatalogue"
                      ? selectedData
                        .map((ele) => ele.KutchaCatalogId)
                        .join(", ")
                      : selectedRows
                        ?.map((ele, index) => ele?.KutchaCatalogId)
                        .join(", "),
                  userId: userId,
                  auctionCenterId: auctionCenterId,
                }
              );

              if (response.data.statusCode === 200) {
                CustomToast.success(response.data.message);
                setOpenDelete(false);
                handleSliceData(idsToSlice);
                setSelectedData([]);
                getkutcha();
                setSelectedRows([]);
                setSelectAll(false);
              } else {
                CustomToast.error(response.data.message);
              }
              closeLoader();
            } catch (error) {
              closeLoader();
              console.error("Error deleting:", error);
              CustomToast.error("An error occurred while deleting.");
            }
          }
        }}
        onHide={() => {
          setOpenDelete(false);
          setSelectedData([]);
        }}
      />
      <UpdateValuation
        openUploadUpdateValuation={openUploadUpdateValuation}
        setOpenUploadUpdateValuation={setOpenUploadUpdateValuation}
        getDataByPrems={getDataByPrems}
        auctionCatalogDetail={formik.values}
        setGetDataByprems={setGetDataByprems}
        auctioncatalogIdforupload={auctioncatalogIdforupload}
        baseUrlEng={"EnglishAuctionKutchaCatalogue"}
        kutchaCatalog={true}
        saleProgramId={saleProgramId}
        userRole="auctioneer"
        resetgetkuchacatalog={() => getkutcha()}
      />
      {/* confirmation model 422*/}
      <Modals
        show={openModalConformation}
        size="xl"
        // onHide={() => setShow(false)}
        handleClose={() => {
          setOpenModalConformation(false);
          setDataFlag(false);
        }}
        dialogClassName="modal-90w"
        aria-labelledby="example-custom-modal-styling-title"
        title="Confirmation Message"
      >
        <div>
          <ul>{openModalConformationTitle}</ul>
        </div>
        {baseUrlEng === "EnglishAuctionKutchaCatalogue" && (
          <>
            <br />
            <div>
              <ul>
                ● If you want the system to automatically delete the associated
                sample and shortage data for the packages click{" "}
                <b>Yes, Delete and Proceed</b>
              </ul>

              <ul>
                ● If you want to keep the existing sample and shortage data and
                delete package no. manually, click <b>NO, Manually Delete</b>
              </ul>
            </div>
          </>
        )}
        <div className="BtnGroup" style={{ justifyContent: "end" }}>
          {baseUrlEng === "EnglishAuctionKutchaCatalogue" ? (
            <>
              <button
                // className="SubmitBtn"
                className="SubmitBtn"
                type="button"
                onClick={() => {
                  // formik.handleSubmit();
                  commitChanges(changed);
                }}
              >
                Yes, Delete and Proceed
              </button>

              <button
                type="button"
                className="SubmitBtn"
                // className="SubmitBtn"
                onClick={() => {
                  setDataFlag(false);
                  setOpenModalConformation(false);
                }}
              >
                NO, Manually Delete
              </button>
            </>
          ) : (
            <>
              <button
                // className="SubmitBtn"
                className="SubmitBtn"
                type="button"
                onClick={() => {
                  formik.handleSubmit();
                }}
              >
                Yes
              </button>

              <button
                type="button"
                className="SubmitBtn"
                // className="SubmitBtn"
                onClick={() => {
                  setDataFlag(false);
                  setOpenModalConformation(false);
                }}
              >
                No
              </button>
            </>
          )}
        </div>
      </Modals>
    </div>
  );
};

export default KutchaTable;
